/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as OrganizationsRouteRouteImport } from './routes/organizations/route'
import { Route as OneauthRouteRouteImport } from './routes/oneauth/route'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as CannyRouteRouteImport } from './routes/canny/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as OnboardingProfileRouteRouteImport } from './routes/onboarding/profile/route'
import { Route as OnboardingRouteWapperRouteRouteImport } from './routes/onboarding/_route-wapper/route'
import { Route as OauthCallbacksCallbackRouteRouteImport } from './routes/_oauth-callbacks/callback/route'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedAssessmentsIndexRouteImport } from './routes/_authenticated/assessments/index'
import { Route as AuthenticatedSettingsManageTeamRouteImport } from './routes/_authenticated/settings/manage-team'
import { Route as AuthenticatedAssessmentsAssessmentsIdRouteImport } from './routes/_authenticated/assessments/$assessmentsId'
import { Route as AuthenticatedAppsGmailRouteImport } from './routes/_authenticated/apps/gmail'
import { Route as AuthAuthSetPasswordRouteImport } from './routes/_auth/auth/set-password'
import { Route as AuthenticatedJobsJobIdRouteRouteImport } from './routes/_authenticated/jobs/$jobId/route'
import { Route as AuthAuthTalentScoutRouteRouteImport } from './routes/_auth/auth/talent-scout/route'
import { Route as AuthenticatedClientsClientIdIndexRouteImport } from './routes/_authenticated/clients/$clientId/index'
import { Route as AuthAuthCallbackIndexRouteImport } from './routes/_auth/auth/callback/index'
import { Route as AuthenticatedJobsJobIdConfigureRouteRouteImport } from './routes/_authenticated/jobs/$jobId/configure/route'
import { Route as AuthenticatedClientsClientIdSubmissionIndexRouteImport } from './routes/_authenticated/clients/$clientId/submission/index'
import { Route as AuthenticatedClientsClientIdSubmissionSubmissionIdRouteImport } from './routes/_authenticated/clients/$clientId/submission/$submissionId'

const OrganizationsIndexLazyRouteImport = createFileRoute('/organizations/')()
const OrgNotFoundLazyRouteImport = createFileRoute('/org/not-found')()
const OneauthConnectLazyRouteImport = createFileRoute('/oneauth/connect')()
const OneauthTokenLazyRouteImport = createFileRoute('/oneauth/$token')()
const CannySsoLazyRouteImport = createFileRoute('/canny/sso')()
const AuthenticatedDeveloperHubLazyRouteImport = createFileRoute(
  '/_authenticated/developer-hub',
)()
const AuthUnsubscribeLazyRouteImport = createFileRoute('/_auth/unsubscribe')()
const AuthForgotPasswordLazyRouteImport = createFileRoute(
  '/_auth/forgot-password',
)()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const AuthenticatedSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const OnboardingProfileIndexLazyRouteImport = createFileRoute(
  '/onboarding/profile/',
)()
const AuthenticatedTalentScoutIndexLazyRouteImport = createFileRoute(
  '/_authenticated/talent-scout/',
)()
const AuthenticatedSupportIndexLazyRouteImport = createFileRoute(
  '/_authenticated/support/',
)()
const AuthenticatedSubmissionsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/submissions/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedResdbIndexLazyRouteImport = createFileRoute(
  '/_authenticated/resdb/',
)()
const AuthenticatedJobsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/',
)()
const AuthenticatedInterviewsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/interviews/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedDatabaseIndexLazyRouteImport = createFileRoute(
  '/_authenticated/database/',
)()
const AuthenticatedCalendarIndexLazyRouteImport = createFileRoute(
  '/_authenticated/calendar/',
)()
const AuthenticatedAppsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/apps/',
)()
const AuthSignUpIndexLazyRouteImport = createFileRoute('/_auth/sign-up/')()
const ReportsCandidateReportRidLazyRouteImport = createFileRoute(
  '/reports/candidate-report/$rid',
)()
const OnboardingRouteWapperSuccessLazyRouteImport = createFileRoute(
  '/onboarding/_route-wapper/success',
)()
const OnboardingRouteWapperCreateOrgLazyRouteImport = createFileRoute(
  '/onboarding/_route-wapper/create-org',
)()
const OauthCallbacksCallbackZoomOauthLazyRouteImport = createFileRoute(
  '/_oauth-callbacks/callback/zoom-oauth',
)()
const OauthCallbacksCallbackMicrosoftOauthLazyRouteImport = createFileRoute(
  '/_oauth-callbacks/callback/microsoft-oauth',
)()
const OauthCallbacksCallbackGoogleOauthLazyRouteImport = createFileRoute(
  '/_oauth-callbacks/callback/google-oauth',
)()
const AuthenticatedTalentScoutRecordIdLazyRouteImport = createFileRoute(
  '/_authenticated/talent-scout/$recordId',
)()
const AuthenticatedSettingsWorkspaceIntegrityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/workspace-integrity',
)()
const AuthenticatedSettingsWebhooksLazyRouteImport = createFileRoute(
  '/_authenticated/settings/webhooks',
)()
const AuthenticatedSettingsVoiceVerificationLazyRouteImport = createFileRoute(
  '/_authenticated/settings/voice-verification',
)()
const AuthenticatedSettingsVocalIntelligenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/vocal-intelligence',
)()
const AuthenticatedSettingsVisualAttentionLazyRouteImport = createFileRoute(
  '/_authenticated/settings/visual-attention',
)()
const AuthenticatedSettingsVisionLazyRouteImport = createFileRoute(
  '/_authenticated/settings/vision',
)()
const AuthenticatedSettingsVideoInterviewLazyRouteImport = createFileRoute(
  '/_authenticated/settings/video-interview',
)()
const AuthenticatedSettingsVelocityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/velocity',
)()
const AuthenticatedSettingsUniversalSearchLazyRouteImport = createFileRoute(
  '/_authenticated/settings/universal-search',
)()
const AuthenticatedSettingsTalentGraphLazyRouteImport = createFileRoute(
  '/_authenticated/settings/talent-graph',
)()
const AuthenticatedSettingsTalentDiscoveryLazyRouteImport = createFileRoute(
  '/_authenticated/settings/talent-discovery',
)()
const AuthenticatedSettingsTalentAcquisitionLazyRouteImport = createFileRoute(
  '/_authenticated/settings/talent-acquisition',
)()
const AuthenticatedSettingsSpeechIntelligenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/speech-intelligence',
)()
const AuthenticatedSettingsSimulationLazyRouteImport = createFileRoute(
  '/_authenticated/settings/simulation',
)()
const AuthenticatedSettingsSecurityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/security',
)()
const AuthenticatedSettingsRetentionLazyRouteImport = createFileRoute(
  '/_authenticated/settings/retention',
)()
const AuthenticatedSettingsResumeTrustLazyRouteImport = createFileRoute(
  '/_authenticated/settings/resume-trust',
)()
const AuthenticatedSettingsResumeIntelligenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/resume-intelligence',
)()
const AuthenticatedSettingsRecruitmentCommsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/recruitment-comms',
)()
const AuthenticatedSettingsRecruitmentLazyRouteImport = createFileRoute(
  '/_authenticated/settings/recruitment',
)()
const AuthenticatedSettingsRecruiterWorkspaceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/recruiter-workspace',
)()
const AuthenticatedSettingsPipelinesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/pipelines',
)()
const AuthenticatedSettingsPersonPresenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/person-presence',
)()
const AuthenticatedSettingsOpportunityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/opportunity',
)()
const AuthenticatedSettingsOfferIntelligenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/offer-intelligence',
)()
const AuthenticatedSettingsJobQualityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/job-quality',
)()
const AuthenticatedSettingsInterviewPracticeLazyRouteImport = createFileRoute(
  '/_authenticated/settings/interview-practice',
)()
const AuthenticatedSettingsInterviewIntelligenceLazyRouteImport =
  createFileRoute('/_authenticated/settings/interview-intelligence')()
const AuthenticatedSettingsInterviewIntegrityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/interview-integrity',
)()
const AuthenticatedSettingsInterviewCopilotLazyRouteImport = createFileRoute(
  '/_authenticated/settings/interview-copilot',
)()
const AuthenticatedSettingsHiringPredictionsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/hiring-predictions',
)()
const AuthenticatedSettingsHiringIntelligenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/hiring-intelligence',
)()
const AuthenticatedSettingsHiringBlueprintLazyRouteImport = createFileRoute(
  '/_authenticated/settings/hiring-blueprint',
)()
const AuthenticatedSettingsHeadPoseLazyRouteImport = createFileRoute(
  '/_authenticated/settings/head-pose',
)()
const AuthenticatedSettingsFacePresenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/face-presence',
)()
const AuthenticatedSettingsEnterpriseLazyRouteImport = createFileRoute(
  '/_authenticated/settings/enterprise',
)()
const AuthenticatedSettingsEngineeringSimLazyRouteImport = createFileRoute(
  '/_authenticated/settings/engineering-sim',
)()
const AuthenticatedSettingsDevicePresenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/device-presence',
)()
const AuthenticatedSettingsDeiLazyRouteImport = createFileRoute(
  '/_authenticated/settings/dei',
)()
const AuthenticatedSettingsDecisionIntelligenceLazyRouteImport =
  createFileRoute('/_authenticated/settings/decision-intelligence')()
const AuthenticatedSettingsCustomReportsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/custom-reports',
)()
const AuthenticatedSettingsCrmSequencesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/crm-sequences',
)()
const AuthenticatedSettingsCredentialLazyRouteImport = createFileRoute(
  '/_authenticated/settings/credential',
)()
const AuthenticatedSettingsCompensationLazyRouteImport = createFileRoute(
  '/_authenticated/settings/compensation',
)()
const AuthenticatedSettingsCommunicationsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/communications',
)()
const AuthenticatedSettingsCareerTwinLazyRouteImport = createFileRoute(
  '/_authenticated/settings/career-twin',
)()
const AuthenticatedSettingsCareerPagesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/career-pages',
)()
const AuthenticatedSettingsCareerIntelligenceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/career-intelligence',
)()
const AuthenticatedSettingsCandidateWorkspaceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/candidate-workspace',
)()
const AuthenticatedSettingsCandidateSuccessLazyRouteImport = createFileRoute(
  '/_authenticated/settings/candidate-success',
)()
const AuthenticatedSettingsCandidateJourneyLazyRouteImport = createFileRoute(
  '/_authenticated/settings/candidate-journey',
)()
const AuthenticatedSettingsCandidateIdentityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/candidate-identity',
)()
const AuthenticatedSettingsCandidateGrowthLazyRouteImport = createFileRoute(
  '/_authenticated/settings/candidate-growth',
)()
const AuthenticatedSettingsCandidateExperienceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/candidate-experience',
)()
const AuthenticatedSettingsCalendarAvailabilityLazyRouteImport =
  createFileRoute('/_authenticated/settings/calendar-availability')()
const AuthenticatedSettingsBrowserIntegrityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/browser-integrity',
)()
const AuthenticatedSettingsBrowserFocusLazyRouteImport = createFileRoute(
  '/_authenticated/settings/browser-focus',
)()
const AuthenticatedSettingsBillingLazyRouteImport = createFileRoute(
  '/_authenticated/settings/billing',
)()
const AuthenticatedSettingsBehavioralLazyRouteImport = createFileRoute(
  '/_authenticated/settings/behavioral',
)()
const AuthenticatedSettingsAudioMonitorLazyRouteImport = createFileRoute(
  '/_authenticated/settings/audio-monitor',
)()
const AuthenticatedSettingsAssessmentLazyRouteImport = createFileRoute(
  '/_authenticated/settings/assessment',
)()
const AuthenticatedSettingsApiKeysLazyRouteImport = createFileRoute(
  '/_authenticated/settings/api-keys',
)()
const AuthenticatedSettingsAnalyticsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/analytics',
)()
const AuthenticatedSettingsAiSourcingLazyRouteImport = createFileRoute(
  '/_authenticated/settings/ai-sourcing',
)()
const AuthenticatedSettingsAiObservabilityLazyRouteImport = createFileRoute(
  '/_authenticated/settings/ai-observability',
)()
const AuthenticatedSettingsAiFeaturesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/ai-features',
)()
const AuthenticatedSettingsActivityLogLazyRouteImport = createFileRoute(
  '/_authenticated/settings/activity-log',
)()
const AuthenticatedResdbIdLazyRouteImport = createFileRoute(
  '/_authenticated/resdb/$id',
)()
const AuthenticatedJobsCreateLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/create',
)()
const AuthenticatedInterviewsDossierLazyRouteImport = createFileRoute(
  '/_authenticated/interviews/dossier',
)()
const AuthenticatedDatabaseSyncLazyRouteImport = createFileRoute(
  '/_authenticated/database/sync',
)()
const AuthenticatedAppsZoomLazyRouteImport = createFileRoute(
  '/_authenticated/apps/zoom',
)()
const AuthenticatedAppsZohodeskLazyRouteImport = createFileRoute(
  '/_authenticated/apps/zohodesk',
)()
const AuthenticatedAppsTwilioWhatsappLazyRouteImport = createFileRoute(
  '/_authenticated/apps/twilio-whatsapp',
)()
const AuthenticatedAppsSlackLazyRouteImport = createFileRoute(
  '/_authenticated/apps/slack',
)()
const AuthenticatedAppsRipplingLazyRouteImport = createFileRoute(
  '/_authenticated/apps/rippling',
)()
const AuthenticatedAppsOutlookCalendarLazyRouteImport = createFileRoute(
  '/_authenticated/apps/outlook-calendar',
)()
const AuthenticatedAppsOutlookLazyRouteImport = createFileRoute(
  '/_authenticated/apps/outlook',
)()
const AuthenticatedAppsNaukriLazyRouteImport = createFileRoute(
  '/_authenticated/apps/naukri',
)()
const AuthenticatedAppsMicrosoftTeamsLazyRouteImport = createFileRoute(
  '/_authenticated/apps/microsoft-teams',
)()
const AuthenticatedAppsMailchimpLazyRouteImport = createFileRoute(
  '/_authenticated/apps/mailchimp',
)()
const AuthenticatedAppsLinkedinLazyRouteImport = createFileRoute(
  '/_authenticated/apps/linkedin',
)()
const AuthenticatedAppsIndeedLazyRouteImport = createFileRoute(
  '/_authenticated/apps/indeed',
)()
const AuthenticatedAppsHackerrankLazyRouteImport = createFileRoute(
  '/_authenticated/apps/hackerrank',
)()
const AuthenticatedAppsGoogleCalendarLazyRouteImport = createFileRoute(
  '/_authenticated/apps/google-calendar',
)()
const AuthenticatedAppsCheckrLazyRouteImport = createFileRoute(
  '/_authenticated/apps/checkr',
)()
const AuthSignUpEmailSentLazyRouteImport = createFileRoute(
  '/_auth/sign-up/email-sent',
)()
const AuthenticatedSettingsOperationLogIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/operation-log/',
)()
const AuthenticatedOnboardingCompleteIndexLazyRouteImport = createFileRoute(
  '/_authenticated/onboarding/complete/',
)()
const AuthenticatedJobsJobIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/',
)()
const AuthAuthTalentScoutIndexLazyRouteImport = createFileRoute(
  '/_auth/auth/talent-scout/',
)()
const AuthenticatedSettingsOperationLogOperation_idLazyRouteImport =
  createFileRoute('/_authenticated/settings/operation-log/$operation_id')()
const AuthenticatedSettingsDatabaseExportLazyRouteImport = createFileRoute(
  '/_authenticated/settings/database/export',
)()
const AuthenticatedJobsJobIdSourceCandidatesLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/source-candidates',
)()
const AuthenticatedJobsJobIdRefineLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/refine',
)()
const AuthenticatedJobsJobIdRecommendationsLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/recommendations',
)()
const AuthenticatedJobsJobIdClientSubmissionsLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/client-submissions',
)()
const AuthenticatedDatabaseCandidateIdLazyRouteImport = createFileRoute(
  '/_authenticated/database/candidate/$id',
)()
const AuthenticatedAppsCallbackGoogleOauthLazyRouteImport = createFileRoute(
  '/_authenticated/apps/callback/google-oauth',
)()
const AuthenticatedJobsJobIdAssessmentsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/assessments/',
)()
const AuthenticatedJobsJobIdConfigureTriggersLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/configure/triggers',
)()
const AuthenticatedJobsJobIdConfigurePublishLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/configure/publish',
)()
const AuthenticatedJobsJobIdConfigureExportLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/configure/export',
)()
const AuthenticatedJobsJobIdCandidateIdLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/candidate/$id',
)()

const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRouteRoute = OrganizationsRouteRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const OneauthRouteRoute = OneauthRouteRouteImport.update({
  id: '/oneauth',
  path: '/oneauth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const CannyRouteRoute = CannyRouteRouteImport.update({
  id: '/canny',
  path: '/canny',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexLazyRoute = OrganizationsIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationsRouteRoute,
} as any).lazy(() =>
  import('./routes/organizations/index.lazy').then((d) => d.Route),
)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const OrgNotFoundLazyRoute = OrgNotFoundLazyRouteImport.update({
  id: '/org/not-found',
  path: '/org/not-found',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/org/not-found.lazy').then((d) => d.Route))
const OneauthConnectLazyRoute = OneauthConnectLazyRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => OneauthRouteRoute,
} as any).lazy(() =>
  import('./routes/oneauth/connect.lazy').then((d) => d.Route),
)
const OneauthTokenLazyRoute = OneauthTokenLazyRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => OneauthRouteRoute,
} as any).lazy(() =>
  import('./routes/oneauth/$token.lazy').then((d) => d.Route),
)
const CannySsoLazyRoute = CannySsoLazyRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => CannyRouteRoute,
} as any).lazy(() => import('./routes/canny/sso.lazy').then((d) => d.Route))
const AuthenticatedDeveloperHubLazyRoute =
  AuthenticatedDeveloperHubLazyRouteImport.update({
    id: '/developer-hub',
    path: '/developer-hub',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/developer-hub.lazy').then((d) => d.Route),
  )
const AuthUnsubscribeLazyRoute = AuthUnsubscribeLazyRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/unsubscribe.lazy').then((d) => d.Route),
)
const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/forgot-password.lazy').then((d) => d.Route),
)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./routes/_auth/login.lazy').then((d) => d.Route))
const OnboardingProfileRouteRoute = OnboardingProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingRouteWapperRouteRoute =
  OnboardingRouteWapperRouteRouteImport.update({
    id: '/_route-wapper',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const OauthCallbacksCallbackRouteRoute =
  OauthCallbacksCallbackRouteRouteImport.update({
    id: '/_oauth-callbacks/callback',
    path: '/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingProfileIndexLazyRoute =
  OnboardingProfileIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OnboardingProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/profile/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTalentScoutIndexLazyRoute =
  AuthenticatedTalentScoutIndexLazyRouteImport.update({
    id: '/talent-scout/',
    path: '/talent-scout/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/talent-scout/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSupportIndexLazyRoute =
  AuthenticatedSupportIndexLazyRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/support/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSubmissionsIndexLazyRoute =
  AuthenticatedSubmissionsIndexLazyRouteImport.update({
    id: '/submissions/',
    path: '/submissions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/submissions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedResdbIndexLazyRoute =
  AuthenticatedResdbIndexLazyRouteImport.update({
    id: '/resdb/',
    path: '/resdb/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resdb/index.lazy').then((d) => d.Route),
  )
const AuthenticatedJobsIndexLazyRoute =
  AuthenticatedJobsIndexLazyRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/index.lazy').then((d) => d.Route),
  )
const AuthenticatedInterviewsIndexLazyRoute =
  AuthenticatedInterviewsIndexLazyRouteImport.update({
    id: '/interviews/',
    path: '/interviews/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/interviews/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDatabaseIndexLazyRoute =
  AuthenticatedDatabaseIndexLazyRouteImport.update({
    id: '/database/',
    path: '/database/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/database/index.lazy').then((d) => d.Route),
  )
const AuthenticatedCalendarIndexLazyRoute =
  AuthenticatedCalendarIndexLazyRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/calendar/index.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsIndexLazyRoute =
  AuthenticatedAppsIndexLazyRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/index.lazy').then((d) => d.Route),
  )
const AuthSignUpIndexLazyRoute = AuthSignUpIndexLazyRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/sign-up/index.lazy').then((d) => d.Route),
)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssessmentsIndexRoute =
  AuthenticatedAssessmentsIndexRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ReportsCandidateReportRidLazyRoute =
  ReportsCandidateReportRidLazyRouteImport.update({
    id: '/reports/candidate-report/$rid',
    path: '/reports/candidate-report/$rid',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/reports/candidate-report/$rid.lazy').then((d) => d.Route),
  )
const OnboardingRouteWapperSuccessLazyRoute =
  OnboardingRouteWapperSuccessLazyRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => OnboardingRouteWapperRouteRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/_route-wapper/success.lazy').then(
      (d) => d.Route,
    ),
  )
const OnboardingRouteWapperCreateOrgLazyRoute =
  OnboardingRouteWapperCreateOrgLazyRouteImport.update({
    id: '/create-org',
    path: '/create-org',
    getParentRoute: () => OnboardingRouteWapperRouteRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/_route-wapper/create-org.lazy').then(
      (d) => d.Route,
    ),
  )
const OauthCallbacksCallbackZoomOauthLazyRoute =
  OauthCallbacksCallbackZoomOauthLazyRouteImport.update({
    id: '/zoom-oauth',
    path: '/zoom-oauth',
    getParentRoute: () => OauthCallbacksCallbackRouteRoute,
  } as any).lazy(() =>
    import('./routes/_oauth-callbacks/callback/zoom-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const OauthCallbacksCallbackMicrosoftOauthLazyRoute =
  OauthCallbacksCallbackMicrosoftOauthLazyRouteImport.update({
    id: '/microsoft-oauth',
    path: '/microsoft-oauth',
    getParentRoute: () => OauthCallbacksCallbackRouteRoute,
  } as any).lazy(() =>
    import('./routes/_oauth-callbacks/callback/microsoft-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const OauthCallbacksCallbackGoogleOauthLazyRoute =
  OauthCallbacksCallbackGoogleOauthLazyRouteImport.update({
    id: '/google-oauth',
    path: '/google-oauth',
    getParentRoute: () => OauthCallbacksCallbackRouteRoute,
  } as any).lazy(() =>
    import('./routes/_oauth-callbacks/callback/google-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTalentScoutRecordIdLazyRoute =
  AuthenticatedTalentScoutRecordIdLazyRouteImport.update({
    id: '/talent-scout/$recordId',
    path: '/talent-scout/$recordId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/talent-scout/$recordId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsWorkspaceIntegrityLazyRoute =
  AuthenticatedSettingsWorkspaceIntegrityLazyRouteImport.update({
    id: '/workspace-integrity',
    path: '/workspace-integrity',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/workspace-integrity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsWebhooksLazyRoute =
  AuthenticatedSettingsWebhooksLazyRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/webhooks.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsVoiceVerificationLazyRoute =
  AuthenticatedSettingsVoiceVerificationLazyRouteImport.update({
    id: '/voice-verification',
    path: '/voice-verification',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/voice-verification.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsVocalIntelligenceLazyRoute =
  AuthenticatedSettingsVocalIntelligenceLazyRouteImport.update({
    id: '/vocal-intelligence',
    path: '/vocal-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/vocal-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsVisualAttentionLazyRoute =
  AuthenticatedSettingsVisualAttentionLazyRouteImport.update({
    id: '/visual-attention',
    path: '/visual-attention',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/visual-attention.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsVisionLazyRoute =
  AuthenticatedSettingsVisionLazyRouteImport.update({
    id: '/vision',
    path: '/vision',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/vision.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsVideoInterviewLazyRoute =
  AuthenticatedSettingsVideoInterviewLazyRouteImport.update({
    id: '/video-interview',
    path: '/video-interview',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/video-interview.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsVelocityLazyRoute =
  AuthenticatedSettingsVelocityLazyRouteImport.update({
    id: '/velocity',
    path: '/velocity',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/velocity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsUniversalSearchLazyRoute =
  AuthenticatedSettingsUniversalSearchLazyRouteImport.update({
    id: '/universal-search',
    path: '/universal-search',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/universal-search.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsTalentGraphLazyRoute =
  AuthenticatedSettingsTalentGraphLazyRouteImport.update({
    id: '/talent-graph',
    path: '/talent-graph',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/talent-graph.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsTalentDiscoveryLazyRoute =
  AuthenticatedSettingsTalentDiscoveryLazyRouteImport.update({
    id: '/talent-discovery',
    path: '/talent-discovery',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/talent-discovery.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsTalentAcquisitionLazyRoute =
  AuthenticatedSettingsTalentAcquisitionLazyRouteImport.update({
    id: '/talent-acquisition',
    path: '/talent-acquisition',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/talent-acquisition.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsSpeechIntelligenceLazyRoute =
  AuthenticatedSettingsSpeechIntelligenceLazyRouteImport.update({
    id: '/speech-intelligence',
    path: '/speech-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/speech-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsSimulationLazyRoute =
  AuthenticatedSettingsSimulationLazyRouteImport.update({
    id: '/simulation',
    path: '/simulation',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/simulation.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsSecurityLazyRoute =
  AuthenticatedSettingsSecurityLazyRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/security.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsRetentionLazyRoute =
  AuthenticatedSettingsRetentionLazyRouteImport.update({
    id: '/retention',
    path: '/retention',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/retention.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsResumeTrustLazyRoute =
  AuthenticatedSettingsResumeTrustLazyRouteImport.update({
    id: '/resume-trust',
    path: '/resume-trust',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/resume-trust.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsResumeIntelligenceLazyRoute =
  AuthenticatedSettingsResumeIntelligenceLazyRouteImport.update({
    id: '/resume-intelligence',
    path: '/resume-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/resume-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsRecruitmentCommsLazyRoute =
  AuthenticatedSettingsRecruitmentCommsLazyRouteImport.update({
    id: '/recruitment-comms',
    path: '/recruitment-comms',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/recruitment-comms.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsRecruitmentLazyRoute =
  AuthenticatedSettingsRecruitmentLazyRouteImport.update({
    id: '/recruitment',
    path: '/recruitment',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/recruitment.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsRecruiterWorkspaceLazyRoute =
  AuthenticatedSettingsRecruiterWorkspaceLazyRouteImport.update({
    id: '/recruiter-workspace',
    path: '/recruiter-workspace',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/recruiter-workspace.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsPipelinesLazyRoute =
  AuthenticatedSettingsPipelinesLazyRouteImport.update({
    id: '/pipelines',
    path: '/pipelines',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/pipelines.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsPersonPresenceLazyRoute =
  AuthenticatedSettingsPersonPresenceLazyRouteImport.update({
    id: '/person-presence',
    path: '/person-presence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/person-presence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsOpportunityLazyRoute =
  AuthenticatedSettingsOpportunityLazyRouteImport.update({
    id: '/opportunity',
    path: '/opportunity',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/opportunity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsOfferIntelligenceLazyRoute =
  AuthenticatedSettingsOfferIntelligenceLazyRouteImport.update({
    id: '/offer-intelligence',
    path: '/offer-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/offer-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsJobQualityLazyRoute =
  AuthenticatedSettingsJobQualityLazyRouteImport.update({
    id: '/job-quality',
    path: '/job-quality',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/job-quality.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsInterviewPracticeLazyRoute =
  AuthenticatedSettingsInterviewPracticeLazyRouteImport.update({
    id: '/interview-practice',
    path: '/interview-practice',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/interview-practice.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsInterviewIntelligenceLazyRoute =
  AuthenticatedSettingsInterviewIntelligenceLazyRouteImport.update({
    id: '/interview-intelligence',
    path: '/interview-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/interview-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsInterviewIntegrityLazyRoute =
  AuthenticatedSettingsInterviewIntegrityLazyRouteImport.update({
    id: '/interview-integrity',
    path: '/interview-integrity',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/interview-integrity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsInterviewCopilotLazyRoute =
  AuthenticatedSettingsInterviewCopilotLazyRouteImport.update({
    id: '/interview-copilot',
    path: '/interview-copilot',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/interview-copilot.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsHiringPredictionsLazyRoute =
  AuthenticatedSettingsHiringPredictionsLazyRouteImport.update({
    id: '/hiring-predictions',
    path: '/hiring-predictions',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/hiring-predictions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsHiringIntelligenceLazyRoute =
  AuthenticatedSettingsHiringIntelligenceLazyRouteImport.update({
    id: '/hiring-intelligence',
    path: '/hiring-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/hiring-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsHiringBlueprintLazyRoute =
  AuthenticatedSettingsHiringBlueprintLazyRouteImport.update({
    id: '/hiring-blueprint',
    path: '/hiring-blueprint',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/hiring-blueprint.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsHeadPoseLazyRoute =
  AuthenticatedSettingsHeadPoseLazyRouteImport.update({
    id: '/head-pose',
    path: '/head-pose',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/head-pose.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsFacePresenceLazyRoute =
  AuthenticatedSettingsFacePresenceLazyRouteImport.update({
    id: '/face-presence',
    path: '/face-presence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/face-presence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsEnterpriseLazyRoute =
  AuthenticatedSettingsEnterpriseLazyRouteImport.update({
    id: '/enterprise',
    path: '/enterprise',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/enterprise.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsEngineeringSimLazyRoute =
  AuthenticatedSettingsEngineeringSimLazyRouteImport.update({
    id: '/engineering-sim',
    path: '/engineering-sim',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/engineering-sim.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsDevicePresenceLazyRoute =
  AuthenticatedSettingsDevicePresenceLazyRouteImport.update({
    id: '/device-presence',
    path: '/device-presence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/device-presence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsDeiLazyRoute =
  AuthenticatedSettingsDeiLazyRouteImport.update({
    id: '/dei',
    path: '/dei',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/dei.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsDecisionIntelligenceLazyRoute =
  AuthenticatedSettingsDecisionIntelligenceLazyRouteImport.update({
    id: '/decision-intelligence',
    path: '/decision-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/decision-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCustomReportsLazyRoute =
  AuthenticatedSettingsCustomReportsLazyRouteImport.update({
    id: '/custom-reports',
    path: '/custom-reports',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/custom-reports.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCrmSequencesLazyRoute =
  AuthenticatedSettingsCrmSequencesLazyRouteImport.update({
    id: '/crm-sequences',
    path: '/crm-sequences',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/crm-sequences.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCredentialLazyRoute =
  AuthenticatedSettingsCredentialLazyRouteImport.update({
    id: '/credential',
    path: '/credential',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/credential.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCompensationLazyRoute =
  AuthenticatedSettingsCompensationLazyRouteImport.update({
    id: '/compensation',
    path: '/compensation',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/compensation.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCommunicationsLazyRoute =
  AuthenticatedSettingsCommunicationsLazyRouteImport.update({
    id: '/communications',
    path: '/communications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/communications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCareerTwinLazyRoute =
  AuthenticatedSettingsCareerTwinLazyRouteImport.update({
    id: '/career-twin',
    path: '/career-twin',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/career-twin.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCareerPagesLazyRoute =
  AuthenticatedSettingsCareerPagesLazyRouteImport.update({
    id: '/career-pages',
    path: '/career-pages',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/career-pages.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCareerIntelligenceLazyRoute =
  AuthenticatedSettingsCareerIntelligenceLazyRouteImport.update({
    id: '/career-intelligence',
    path: '/career-intelligence',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/career-intelligence.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCandidateWorkspaceLazyRoute =
  AuthenticatedSettingsCandidateWorkspaceLazyRouteImport.update({
    id: '/candidate-workspace',
    path: '/candidate-workspace',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/candidate-workspace.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCandidateSuccessLazyRoute =
  AuthenticatedSettingsCandidateSuccessLazyRouteImport.update({
    id: '/candidate-success',
    path: '/candidate-success',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/candidate-success.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCandidateJourneyLazyRoute =
  AuthenticatedSettingsCandidateJourneyLazyRouteImport.update({
    id: '/candidate-journey',
    path: '/candidate-journey',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/candidate-journey.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCandidateIdentityLazyRoute =
  AuthenticatedSettingsCandidateIdentityLazyRouteImport.update({
    id: '/candidate-identity',
    path: '/candidate-identity',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/candidate-identity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCandidateGrowthLazyRoute =
  AuthenticatedSettingsCandidateGrowthLazyRouteImport.update({
    id: '/candidate-growth',
    path: '/candidate-growth',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/candidate-growth.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCandidateExperienceLazyRoute =
  AuthenticatedSettingsCandidateExperienceLazyRouteImport.update({
    id: '/candidate-experience',
    path: '/candidate-experience',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/candidate-experience.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCalendarAvailabilityLazyRoute =
  AuthenticatedSettingsCalendarAvailabilityLazyRouteImport.update({
    id: '/calendar-availability',
    path: '/calendar-availability',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/calendar-availability.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBrowserIntegrityLazyRoute =
  AuthenticatedSettingsBrowserIntegrityLazyRouteImport.update({
    id: '/browser-integrity',
    path: '/browser-integrity',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/browser-integrity.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBrowserFocusLazyRoute =
  AuthenticatedSettingsBrowserFocusLazyRouteImport.update({
    id: '/browser-focus',
    path: '/browser-focus',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/browser-focus.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBillingLazyRoute =
  AuthenticatedSettingsBillingLazyRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/billing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBehavioralLazyRoute =
  AuthenticatedSettingsBehavioralLazyRouteImport.update({
    id: '/behavioral',
    path: '/behavioral',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/behavioral.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAudioMonitorLazyRoute =
  AuthenticatedSettingsAudioMonitorLazyRouteImport.update({
    id: '/audio-monitor',
    path: '/audio-monitor',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/audio-monitor.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAssessmentLazyRoute =
  AuthenticatedSettingsAssessmentLazyRouteImport.update({
    id: '/assessment',
    path: '/assessment',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/assessment.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsApiKeysLazyRoute =
  AuthenticatedSettingsApiKeysLazyRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/api-keys.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAnalyticsLazyRoute =
  AuthenticatedSettingsAnalyticsLazyRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/analytics.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAiSourcingLazyRoute =
  AuthenticatedSettingsAiSourcingLazyRouteImport.update({
    id: '/ai-sourcing',
    path: '/ai-sourcing',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/ai-sourcing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAiObservabilityLazyRoute =
  AuthenticatedSettingsAiObservabilityLazyRouteImport.update({
    id: '/ai-observability',
    path: '/ai-observability',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/ai-observability.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAiFeaturesLazyRoute =
  AuthenticatedSettingsAiFeaturesLazyRouteImport.update({
    id: '/ai-features',
    path: '/ai-features',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/ai-features.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsActivityLogLazyRoute =
  AuthenticatedSettingsActivityLogLazyRouteImport.update({
    id: '/activity-log',
    path: '/activity-log',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/activity-log.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedResdbIdLazyRoute =
  AuthenticatedResdbIdLazyRouteImport.update({
    id: '/resdb/$id',
    path: '/resdb/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resdb/$id.lazy').then((d) => d.Route),
  )
const AuthenticatedJobsCreateLazyRoute =
  AuthenticatedJobsCreateLazyRouteImport.update({
    id: '/jobs/create',
    path: '/jobs/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/create.lazy').then((d) => d.Route),
  )
const AuthenticatedInterviewsDossierLazyRoute =
  AuthenticatedInterviewsDossierLazyRouteImport.update({
    id: '/interviews/dossier',
    path: '/interviews/dossier',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/interviews/dossier.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDatabaseSyncLazyRoute =
  AuthenticatedDatabaseSyncLazyRouteImport.update({
    id: '/database/sync',
    path: '/database/sync',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/database/sync.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsZoomLazyRoute =
  AuthenticatedAppsZoomLazyRouteImport.update({
    id: '/apps/zoom',
    path: '/apps/zoom',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/zoom.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsZohodeskLazyRoute =
  AuthenticatedAppsZohodeskLazyRouteImport.update({
    id: '/apps/zohodesk',
    path: '/apps/zohodesk',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/zohodesk.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsTwilioWhatsappLazyRoute =
  AuthenticatedAppsTwilioWhatsappLazyRouteImport.update({
    id: '/apps/twilio-whatsapp',
    path: '/apps/twilio-whatsapp',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/twilio-whatsapp.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsSlackLazyRoute =
  AuthenticatedAppsSlackLazyRouteImport.update({
    id: '/apps/slack',
    path: '/apps/slack',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/slack.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsRipplingLazyRoute =
  AuthenticatedAppsRipplingLazyRouteImport.update({
    id: '/apps/rippling',
    path: '/apps/rippling',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/rippling.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsOutlookCalendarLazyRoute =
  AuthenticatedAppsOutlookCalendarLazyRouteImport.update({
    id: '/apps/outlook-calendar',
    path: '/apps/outlook-calendar',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/outlook-calendar.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsOutlookLazyRoute =
  AuthenticatedAppsOutlookLazyRouteImport.update({
    id: '/apps/outlook',
    path: '/apps/outlook',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/outlook.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsNaukriLazyRoute =
  AuthenticatedAppsNaukriLazyRouteImport.update({
    id: '/apps/naukri',
    path: '/apps/naukri',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/naukri.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsMicrosoftTeamsLazyRoute =
  AuthenticatedAppsMicrosoftTeamsLazyRouteImport.update({
    id: '/apps/microsoft-teams',
    path: '/apps/microsoft-teams',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/microsoft-teams.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsMailchimpLazyRoute =
  AuthenticatedAppsMailchimpLazyRouteImport.update({
    id: '/apps/mailchimp',
    path: '/apps/mailchimp',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/mailchimp.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsLinkedinLazyRoute =
  AuthenticatedAppsLinkedinLazyRouteImport.update({
    id: '/apps/linkedin',
    path: '/apps/linkedin',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/linkedin.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsIndeedLazyRoute =
  AuthenticatedAppsIndeedLazyRouteImport.update({
    id: '/apps/indeed',
    path: '/apps/indeed',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/indeed.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsHackerrankLazyRoute =
  AuthenticatedAppsHackerrankLazyRouteImport.update({
    id: '/apps/hackerrank',
    path: '/apps/hackerrank',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/hackerrank.lazy').then((d) => d.Route),
  )
const AuthenticatedAppsGoogleCalendarLazyRoute =
  AuthenticatedAppsGoogleCalendarLazyRouteImport.update({
    id: '/apps/google-calendar',
    path: '/apps/google-calendar',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/google-calendar.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsCheckrLazyRoute =
  AuthenticatedAppsCheckrLazyRouteImport.update({
    id: '/apps/checkr',
    path: '/apps/checkr',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/checkr.lazy').then((d) => d.Route),
  )
const AuthSignUpEmailSentLazyRoute = AuthSignUpEmailSentLazyRouteImport.update({
  id: '/sign-up/email-sent',
  path: '/sign-up/email-sent',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/sign-up/email-sent.lazy').then((d) => d.Route),
)
const AuthenticatedSettingsManageTeamRoute =
  AuthenticatedSettingsManageTeamRouteImport.update({
    id: '/manage-team',
    path: '/manage-team',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any)
const AuthenticatedAssessmentsAssessmentsIdRoute =
  AuthenticatedAssessmentsAssessmentsIdRouteImport.update({
    id: '/assessments/$assessmentsId',
    path: '/assessments/$assessmentsId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsGmailRoute = AuthenticatedAppsGmailRouteImport.update({
  id: '/apps/gmail',
  path: '/apps/gmail',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthAuthSetPasswordRoute = AuthAuthSetPasswordRouteImport.update({
  id: '/auth/set-password',
  path: '/auth/set-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedJobsJobIdRouteRoute =
  AuthenticatedJobsJobIdRouteRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthAuthTalentScoutRouteRoute =
  AuthAuthTalentScoutRouteRouteImport.update({
    id: '/auth/talent-scout',
    path: '/auth/talent-scout',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthenticatedSettingsOperationLogIndexLazyRoute =
  AuthenticatedSettingsOperationLogIndexLazyRouteImport.update({
    id: '/operation-log/',
    path: '/operation-log/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/operation-log/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOnboardingCompleteIndexLazyRoute =
  AuthenticatedOnboardingCompleteIndexLazyRouteImport.update({
    id: '/onboarding/complete/',
    path: '/onboarding/complete/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/onboarding/complete/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdIndexLazyRoute =
  AuthenticatedJobsJobIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAuthTalentScoutIndexLazyRoute =
  AuthAuthTalentScoutIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthTalentScoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/auth/talent-scout/index.lazy').then((d) => d.Route),
  )
const AuthenticatedClientsClientIdIndexRoute =
  AuthenticatedClientsClientIdIndexRouteImport.update({
    id: '/clients/$clientId/',
    path: '/clients/$clientId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthAuthCallbackIndexRoute = AuthAuthCallbackIndexRouteImport.update({
  id: '/auth/callback/',
  path: '/auth/callback/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedSettingsOperationLogOperation_idLazyRoute =
  AuthenticatedSettingsOperationLogOperation_idLazyRouteImport.update({
    id: '/operation-log/$operation_id',
    path: '/operation-log/$operation_id',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/settings/operation-log/$operation_id.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedSettingsDatabaseExportLazyRoute =
  AuthenticatedSettingsDatabaseExportLazyRouteImport.update({
    id: '/database/export',
    path: '/database/export',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/database/export.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdSourceCandidatesLazyRoute =
  AuthenticatedJobsJobIdSourceCandidatesLazyRouteImport.update({
    id: '/source-candidates',
    path: '/source-candidates',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/source-candidates.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdRefineLazyRoute =
  AuthenticatedJobsJobIdRefineLazyRouteImport.update({
    id: '/refine',
    path: '/refine',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/refine.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdRecommendationsLazyRoute =
  AuthenticatedJobsJobIdRecommendationsLazyRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/recommendations.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdClientSubmissionsLazyRoute =
  AuthenticatedJobsJobIdClientSubmissionsLazyRouteImport.update({
    id: '/client-submissions',
    path: '/client-submissions',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/client-submissions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDatabaseCandidateIdLazyRoute =
  AuthenticatedDatabaseCandidateIdLazyRouteImport.update({
    id: '/database/candidate/$id',
    path: '/database/candidate/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/database/candidate.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAppsCallbackGoogleOauthLazyRoute =
  AuthenticatedAppsCallbackGoogleOauthLazyRouteImport.update({
    id: '/apps/callback/google-oauth',
    path: '/apps/callback/google-oauth',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/apps/callback/google-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigureRouteRoute =
  AuthenticatedJobsJobIdConfigureRouteRouteImport.update({
    id: '/configure',
    path: '/configure',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedJobsJobIdAssessmentsIndexLazyRoute =
  AuthenticatedJobsJobIdAssessmentsIndexLazyRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/assessments/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedClientsClientIdSubmissionIndexRoute =
  AuthenticatedClientsClientIdSubmissionIndexRouteImport.update({
    id: '/clients/$clientId/submission/',
    path: '/clients/$clientId/submission/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsJobIdConfigureTriggersLazyRoute =
  AuthenticatedJobsJobIdConfigureTriggersLazyRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => AuthenticatedJobsJobIdConfigureRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/configure/triggers.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigurePublishLazyRoute =
  AuthenticatedJobsJobIdConfigurePublishLazyRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => AuthenticatedJobsJobIdConfigureRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/configure/publish.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigureExportLazyRoute =
  AuthenticatedJobsJobIdConfigureExportLazyRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedJobsJobIdConfigureRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/configure/export.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdCandidateIdLazyRoute =
  AuthenticatedJobsJobIdCandidateIdLazyRouteImport.update({
    id: '/candidate/$id',
    path: '/candidate/$id',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/candidate.$id.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedClientsClientIdSubmissionSubmissionIdRoute =
  AuthenticatedClientsClientIdSubmissionSubmissionIdRouteImport.update({
    id: '/clients/$clientId/submission/$submissionId',
    path: '/clients/$clientId/submission/$submissionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/canny': typeof CannyRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteWapperRouteRouteWithChildren
  '/oneauth': typeof OneauthRouteRouteWithChildren
  '/organizations': typeof OrganizationsRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof OauthCallbacksCallbackRouteRouteWithChildren
  '/onboarding/profile': typeof OnboardingProfileRouteRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/sign-in': typeof AuthSignInRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/unsubscribe': typeof AuthUnsubscribeLazyRoute
  '/developer-hub': typeof AuthenticatedDeveloperHubLazyRoute
  '/canny/sso': typeof CannySsoLazyRoute
  '/oneauth/$token': typeof OneauthTokenLazyRoute
  '/oneauth/connect': typeof OneauthConnectLazyRoute
  '/org/not-found': typeof OrgNotFoundLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations/': typeof OrganizationsIndexLazyRoute
  '/auth/talent-scout': typeof AuthAuthTalentScoutRouteRouteWithChildren
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  '/auth/set-password': typeof AuthAuthSetPasswordRoute
  '/apps/gmail': typeof AuthenticatedAppsGmailRoute
  '/assessments/$assessmentsId': typeof AuthenticatedAssessmentsAssessmentsIdRoute
  '/settings/manage-team': typeof AuthenticatedSettingsManageTeamRoute
  '/sign-up/email-sent': typeof AuthSignUpEmailSentLazyRoute
  '/apps/checkr': typeof AuthenticatedAppsCheckrLazyRoute
  '/apps/google-calendar': typeof AuthenticatedAppsGoogleCalendarLazyRoute
  '/apps/hackerrank': typeof AuthenticatedAppsHackerrankLazyRoute
  '/apps/indeed': typeof AuthenticatedAppsIndeedLazyRoute
  '/apps/linkedin': typeof AuthenticatedAppsLinkedinLazyRoute
  '/apps/mailchimp': typeof AuthenticatedAppsMailchimpLazyRoute
  '/apps/microsoft-teams': typeof AuthenticatedAppsMicrosoftTeamsLazyRoute
  '/apps/naukri': typeof AuthenticatedAppsNaukriLazyRoute
  '/apps/outlook': typeof AuthenticatedAppsOutlookLazyRoute
  '/apps/outlook-calendar': typeof AuthenticatedAppsOutlookCalendarLazyRoute
  '/apps/rippling': typeof AuthenticatedAppsRipplingLazyRoute
  '/apps/slack': typeof AuthenticatedAppsSlackLazyRoute
  '/apps/twilio-whatsapp': typeof AuthenticatedAppsTwilioWhatsappLazyRoute
  '/apps/zohodesk': typeof AuthenticatedAppsZohodeskLazyRoute
  '/apps/zoom': typeof AuthenticatedAppsZoomLazyRoute
  '/database/sync': typeof AuthenticatedDatabaseSyncLazyRoute
  '/interviews/dossier': typeof AuthenticatedInterviewsDossierLazyRoute
  '/jobs/create': typeof AuthenticatedJobsCreateLazyRoute
  '/resdb/$id': typeof AuthenticatedResdbIdLazyRoute
  '/settings/activity-log': typeof AuthenticatedSettingsActivityLogLazyRoute
  '/settings/ai-features': typeof AuthenticatedSettingsAiFeaturesLazyRoute
  '/settings/ai-observability': typeof AuthenticatedSettingsAiObservabilityLazyRoute
  '/settings/ai-sourcing': typeof AuthenticatedSettingsAiSourcingLazyRoute
  '/settings/analytics': typeof AuthenticatedSettingsAnalyticsLazyRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysLazyRoute
  '/settings/assessment': typeof AuthenticatedSettingsAssessmentLazyRoute
  '/settings/audio-monitor': typeof AuthenticatedSettingsAudioMonitorLazyRoute
  '/settings/behavioral': typeof AuthenticatedSettingsBehavioralLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/browser-focus': typeof AuthenticatedSettingsBrowserFocusLazyRoute
  '/settings/browser-integrity': typeof AuthenticatedSettingsBrowserIntegrityLazyRoute
  '/settings/calendar-availability': typeof AuthenticatedSettingsCalendarAvailabilityLazyRoute
  '/settings/candidate-experience': typeof AuthenticatedSettingsCandidateExperienceLazyRoute
  '/settings/candidate-growth': typeof AuthenticatedSettingsCandidateGrowthLazyRoute
  '/settings/candidate-identity': typeof AuthenticatedSettingsCandidateIdentityLazyRoute
  '/settings/candidate-journey': typeof AuthenticatedSettingsCandidateJourneyLazyRoute
  '/settings/candidate-success': typeof AuthenticatedSettingsCandidateSuccessLazyRoute
  '/settings/candidate-workspace': typeof AuthenticatedSettingsCandidateWorkspaceLazyRoute
  '/settings/career-intelligence': typeof AuthenticatedSettingsCareerIntelligenceLazyRoute
  '/settings/career-pages': typeof AuthenticatedSettingsCareerPagesLazyRoute
  '/settings/career-twin': typeof AuthenticatedSettingsCareerTwinLazyRoute
  '/settings/communications': typeof AuthenticatedSettingsCommunicationsLazyRoute
  '/settings/compensation': typeof AuthenticatedSettingsCompensationLazyRoute
  '/settings/credential': typeof AuthenticatedSettingsCredentialLazyRoute
  '/settings/crm-sequences': typeof AuthenticatedSettingsCrmSequencesLazyRoute
  '/settings/custom-reports': typeof AuthenticatedSettingsCustomReportsLazyRoute
  '/settings/decision-intelligence': typeof AuthenticatedSettingsDecisionIntelligenceLazyRoute
  '/settings/dei': typeof AuthenticatedSettingsDeiLazyRoute
  '/settings/device-presence': typeof AuthenticatedSettingsDevicePresenceLazyRoute
  '/settings/engineering-sim': typeof AuthenticatedSettingsEngineeringSimLazyRoute
  '/settings/enterprise': typeof AuthenticatedSettingsEnterpriseLazyRoute
  '/settings/face-presence': typeof AuthenticatedSettingsFacePresenceLazyRoute
  '/settings/head-pose': typeof AuthenticatedSettingsHeadPoseLazyRoute
  '/settings/hiring-blueprint': typeof AuthenticatedSettingsHiringBlueprintLazyRoute
  '/settings/hiring-intelligence': typeof AuthenticatedSettingsHiringIntelligenceLazyRoute
  '/settings/hiring-predictions': typeof AuthenticatedSettingsHiringPredictionsLazyRoute
  '/settings/interview-copilot': typeof AuthenticatedSettingsInterviewCopilotLazyRoute
  '/settings/interview-integrity': typeof AuthenticatedSettingsInterviewIntegrityLazyRoute
  '/settings/interview-intelligence': typeof AuthenticatedSettingsInterviewIntelligenceLazyRoute
  '/settings/interview-practice': typeof AuthenticatedSettingsInterviewPracticeLazyRoute
  '/settings/job-quality': typeof AuthenticatedSettingsJobQualityLazyRoute
  '/settings/offer-intelligence': typeof AuthenticatedSettingsOfferIntelligenceLazyRoute
  '/settings/opportunity': typeof AuthenticatedSettingsOpportunityLazyRoute
  '/settings/person-presence': typeof AuthenticatedSettingsPersonPresenceLazyRoute
  '/settings/pipelines': typeof AuthenticatedSettingsPipelinesLazyRoute
  '/settings/recruiter-workspace': typeof AuthenticatedSettingsRecruiterWorkspaceLazyRoute
  '/settings/recruitment': typeof AuthenticatedSettingsRecruitmentLazyRoute
  '/settings/recruitment-comms': typeof AuthenticatedSettingsRecruitmentCommsLazyRoute
  '/settings/resume-intelligence': typeof AuthenticatedSettingsResumeIntelligenceLazyRoute
  '/settings/resume-trust': typeof AuthenticatedSettingsResumeTrustLazyRoute
  '/settings/retention': typeof AuthenticatedSettingsRetentionLazyRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityLazyRoute
  '/settings/simulation': typeof AuthenticatedSettingsSimulationLazyRoute
  '/settings/speech-intelligence': typeof AuthenticatedSettingsSpeechIntelligenceLazyRoute
  '/settings/talent-acquisition': typeof AuthenticatedSettingsTalentAcquisitionLazyRoute
  '/settings/talent-discovery': typeof AuthenticatedSettingsTalentDiscoveryLazyRoute
  '/settings/talent-graph': typeof AuthenticatedSettingsTalentGraphLazyRoute
  '/settings/universal-search': typeof AuthenticatedSettingsUniversalSearchLazyRoute
  '/settings/velocity': typeof AuthenticatedSettingsVelocityLazyRoute
  '/settings/video-interview': typeof AuthenticatedSettingsVideoInterviewLazyRoute
  '/settings/vision': typeof AuthenticatedSettingsVisionLazyRoute
  '/settings/visual-attention': typeof AuthenticatedSettingsVisualAttentionLazyRoute
  '/settings/vocal-intelligence': typeof AuthenticatedSettingsVocalIntelligenceLazyRoute
  '/settings/voice-verification': typeof AuthenticatedSettingsVoiceVerificationLazyRoute
  '/settings/webhooks': typeof AuthenticatedSettingsWebhooksLazyRoute
  '/settings/workspace-integrity': typeof AuthenticatedSettingsWorkspaceIntegrityLazyRoute
  '/talent-scout/$recordId': typeof AuthenticatedTalentScoutRecordIdLazyRoute
  '/callback/google-oauth': typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  '/callback/microsoft-oauth': typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  '/callback/zoom-oauth': typeof OauthCallbacksCallbackZoomOauthLazyRoute
  '/onboarding/create-org': typeof OnboardingRouteWapperCreateOrgLazyRoute
  '/onboarding/success': typeof OnboardingRouteWapperSuccessLazyRoute
  '/reports/candidate-report/$rid': typeof ReportsCandidateReportRidLazyRoute
  '/assessments': typeof AuthenticatedAssessmentsIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/sign-up': typeof AuthSignUpIndexLazyRoute
  '/apps': typeof AuthenticatedAppsIndexLazyRoute
  '/calendar': typeof AuthenticatedCalendarIndexLazyRoute
  '/database': typeof AuthenticatedDatabaseIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/interviews': typeof AuthenticatedInterviewsIndexLazyRoute
  '/jobs': typeof AuthenticatedJobsIndexLazyRoute
  '/resdb': typeof AuthenticatedResdbIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/submissions': typeof AuthenticatedSubmissionsIndexLazyRoute
  '/support': typeof AuthenticatedSupportIndexLazyRoute
  '/talent-scout': typeof AuthenticatedTalentScoutIndexLazyRoute
  '/onboarding/profile/': typeof OnboardingProfileIndexLazyRoute
  '/jobs/$jobId/configure': typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  '/apps/callback/google-oauth': typeof AuthenticatedAppsCallbackGoogleOauthLazyRoute
  '/database/candidate/$id': typeof AuthenticatedDatabaseCandidateIdLazyRoute
  '/jobs/$jobId/client-submissions': typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  '/jobs/$jobId/recommendations': typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  '/jobs/$jobId/refine': typeof AuthenticatedJobsJobIdRefineLazyRoute
  '/jobs/$jobId/source-candidates': typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  '/settings/database/export': typeof AuthenticatedSettingsDatabaseExportLazyRoute
  '/settings/operation-log/$operation_id': typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  '/auth/callback': typeof AuthAuthCallbackIndexRoute
  '/clients/$clientId': typeof AuthenticatedClientsClientIdIndexRoute
  '/auth/talent-scout/': typeof AuthAuthTalentScoutIndexLazyRoute
  '/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexLazyRoute
  '/onboarding/complete': typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  '/settings/operation-log': typeof AuthenticatedSettingsOperationLogIndexLazyRoute
  '/clients/$clientId/submission/$submissionId': typeof AuthenticatedClientsClientIdSubmissionSubmissionIdRoute
  '/jobs/$jobId/candidate/$id': typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  '/jobs/$jobId/configure/export': typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  '/jobs/$jobId/configure/publish': typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  '/jobs/$jobId/configure/triggers': typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
  '/clients/$clientId/submission': typeof AuthenticatedClientsClientIdSubmissionIndexRoute
  '/jobs/$jobId/assessments': typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/canny': typeof CannyRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteWapperRouteRouteWithChildren
  '/oneauth': typeof OneauthRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof OauthCallbacksCallbackRouteRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/sign-in': typeof AuthSignInRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/unsubscribe': typeof AuthUnsubscribeLazyRoute
  '/developer-hub': typeof AuthenticatedDeveloperHubLazyRoute
  '/canny/sso': typeof CannySsoLazyRoute
  '/oneauth/$token': typeof OneauthTokenLazyRoute
  '/oneauth/connect': typeof OneauthConnectLazyRoute
  '/org/not-found': typeof OrgNotFoundLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations': typeof OrganizationsIndexLazyRoute
  '/auth/set-password': typeof AuthAuthSetPasswordRoute
  '/apps/gmail': typeof AuthenticatedAppsGmailRoute
  '/assessments/$assessmentsId': typeof AuthenticatedAssessmentsAssessmentsIdRoute
  '/settings/manage-team': typeof AuthenticatedSettingsManageTeamRoute
  '/sign-up/email-sent': typeof AuthSignUpEmailSentLazyRoute
  '/apps/checkr': typeof AuthenticatedAppsCheckrLazyRoute
  '/apps/google-calendar': typeof AuthenticatedAppsGoogleCalendarLazyRoute
  '/apps/hackerrank': typeof AuthenticatedAppsHackerrankLazyRoute
  '/apps/indeed': typeof AuthenticatedAppsIndeedLazyRoute
  '/apps/linkedin': typeof AuthenticatedAppsLinkedinLazyRoute
  '/apps/mailchimp': typeof AuthenticatedAppsMailchimpLazyRoute
  '/apps/microsoft-teams': typeof AuthenticatedAppsMicrosoftTeamsLazyRoute
  '/apps/naukri': typeof AuthenticatedAppsNaukriLazyRoute
  '/apps/outlook': typeof AuthenticatedAppsOutlookLazyRoute
  '/apps/outlook-calendar': typeof AuthenticatedAppsOutlookCalendarLazyRoute
  '/apps/rippling': typeof AuthenticatedAppsRipplingLazyRoute
  '/apps/slack': typeof AuthenticatedAppsSlackLazyRoute
  '/apps/twilio-whatsapp': typeof AuthenticatedAppsTwilioWhatsappLazyRoute
  '/apps/zohodesk': typeof AuthenticatedAppsZohodeskLazyRoute
  '/apps/zoom': typeof AuthenticatedAppsZoomLazyRoute
  '/database/sync': typeof AuthenticatedDatabaseSyncLazyRoute
  '/interviews/dossier': typeof AuthenticatedInterviewsDossierLazyRoute
  '/jobs/create': typeof AuthenticatedJobsCreateLazyRoute
  '/resdb/$id': typeof AuthenticatedResdbIdLazyRoute
  '/settings/activity-log': typeof AuthenticatedSettingsActivityLogLazyRoute
  '/settings/ai-features': typeof AuthenticatedSettingsAiFeaturesLazyRoute
  '/settings/ai-observability': typeof AuthenticatedSettingsAiObservabilityLazyRoute
  '/settings/ai-sourcing': typeof AuthenticatedSettingsAiSourcingLazyRoute
  '/settings/analytics': typeof AuthenticatedSettingsAnalyticsLazyRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysLazyRoute
  '/settings/assessment': typeof AuthenticatedSettingsAssessmentLazyRoute
  '/settings/audio-monitor': typeof AuthenticatedSettingsAudioMonitorLazyRoute
  '/settings/behavioral': typeof AuthenticatedSettingsBehavioralLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/browser-focus': typeof AuthenticatedSettingsBrowserFocusLazyRoute
  '/settings/browser-integrity': typeof AuthenticatedSettingsBrowserIntegrityLazyRoute
  '/settings/calendar-availability': typeof AuthenticatedSettingsCalendarAvailabilityLazyRoute
  '/settings/candidate-experience': typeof AuthenticatedSettingsCandidateExperienceLazyRoute
  '/settings/candidate-growth': typeof AuthenticatedSettingsCandidateGrowthLazyRoute
  '/settings/candidate-identity': typeof AuthenticatedSettingsCandidateIdentityLazyRoute
  '/settings/candidate-journey': typeof AuthenticatedSettingsCandidateJourneyLazyRoute
  '/settings/candidate-success': typeof AuthenticatedSettingsCandidateSuccessLazyRoute
  '/settings/candidate-workspace': typeof AuthenticatedSettingsCandidateWorkspaceLazyRoute
  '/settings/career-intelligence': typeof AuthenticatedSettingsCareerIntelligenceLazyRoute
  '/settings/career-pages': typeof AuthenticatedSettingsCareerPagesLazyRoute
  '/settings/career-twin': typeof AuthenticatedSettingsCareerTwinLazyRoute
  '/settings/communications': typeof AuthenticatedSettingsCommunicationsLazyRoute
  '/settings/compensation': typeof AuthenticatedSettingsCompensationLazyRoute
  '/settings/credential': typeof AuthenticatedSettingsCredentialLazyRoute
  '/settings/crm-sequences': typeof AuthenticatedSettingsCrmSequencesLazyRoute
  '/settings/custom-reports': typeof AuthenticatedSettingsCustomReportsLazyRoute
  '/settings/decision-intelligence': typeof AuthenticatedSettingsDecisionIntelligenceLazyRoute
  '/settings/dei': typeof AuthenticatedSettingsDeiLazyRoute
  '/settings/device-presence': typeof AuthenticatedSettingsDevicePresenceLazyRoute
  '/settings/engineering-sim': typeof AuthenticatedSettingsEngineeringSimLazyRoute
  '/settings/enterprise': typeof AuthenticatedSettingsEnterpriseLazyRoute
  '/settings/face-presence': typeof AuthenticatedSettingsFacePresenceLazyRoute
  '/settings/head-pose': typeof AuthenticatedSettingsHeadPoseLazyRoute
  '/settings/hiring-blueprint': typeof AuthenticatedSettingsHiringBlueprintLazyRoute
  '/settings/hiring-intelligence': typeof AuthenticatedSettingsHiringIntelligenceLazyRoute
  '/settings/hiring-predictions': typeof AuthenticatedSettingsHiringPredictionsLazyRoute
  '/settings/interview-copilot': typeof AuthenticatedSettingsInterviewCopilotLazyRoute
  '/settings/interview-integrity': typeof AuthenticatedSettingsInterviewIntegrityLazyRoute
  '/settings/interview-intelligence': typeof AuthenticatedSettingsInterviewIntelligenceLazyRoute
  '/settings/interview-practice': typeof AuthenticatedSettingsInterviewPracticeLazyRoute
  '/settings/job-quality': typeof AuthenticatedSettingsJobQualityLazyRoute
  '/settings/offer-intelligence': typeof AuthenticatedSettingsOfferIntelligenceLazyRoute
  '/settings/opportunity': typeof AuthenticatedSettingsOpportunityLazyRoute
  '/settings/person-presence': typeof AuthenticatedSettingsPersonPresenceLazyRoute
  '/settings/pipelines': typeof AuthenticatedSettingsPipelinesLazyRoute
  '/settings/recruiter-workspace': typeof AuthenticatedSettingsRecruiterWorkspaceLazyRoute
  '/settings/recruitment': typeof AuthenticatedSettingsRecruitmentLazyRoute
  '/settings/recruitment-comms': typeof AuthenticatedSettingsRecruitmentCommsLazyRoute
  '/settings/resume-intelligence': typeof AuthenticatedSettingsResumeIntelligenceLazyRoute
  '/settings/resume-trust': typeof AuthenticatedSettingsResumeTrustLazyRoute
  '/settings/retention': typeof AuthenticatedSettingsRetentionLazyRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityLazyRoute
  '/settings/simulation': typeof AuthenticatedSettingsSimulationLazyRoute
  '/settings/speech-intelligence': typeof AuthenticatedSettingsSpeechIntelligenceLazyRoute
  '/settings/talent-acquisition': typeof AuthenticatedSettingsTalentAcquisitionLazyRoute
  '/settings/talent-discovery': typeof AuthenticatedSettingsTalentDiscoveryLazyRoute
  '/settings/talent-graph': typeof AuthenticatedSettingsTalentGraphLazyRoute
  '/settings/universal-search': typeof AuthenticatedSettingsUniversalSearchLazyRoute
  '/settings/velocity': typeof AuthenticatedSettingsVelocityLazyRoute
  '/settings/video-interview': typeof AuthenticatedSettingsVideoInterviewLazyRoute
  '/settings/vision': typeof AuthenticatedSettingsVisionLazyRoute
  '/settings/visual-attention': typeof AuthenticatedSettingsVisualAttentionLazyRoute
  '/settings/vocal-intelligence': typeof AuthenticatedSettingsVocalIntelligenceLazyRoute
  '/settings/voice-verification': typeof AuthenticatedSettingsVoiceVerificationLazyRoute
  '/settings/webhooks': typeof AuthenticatedSettingsWebhooksLazyRoute
  '/settings/workspace-integrity': typeof AuthenticatedSettingsWorkspaceIntegrityLazyRoute
  '/talent-scout/$recordId': typeof AuthenticatedTalentScoutRecordIdLazyRoute
  '/callback/google-oauth': typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  '/callback/microsoft-oauth': typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  '/callback/zoom-oauth': typeof OauthCallbacksCallbackZoomOauthLazyRoute
  '/onboarding/create-org': typeof OnboardingRouteWapperCreateOrgLazyRoute
  '/onboarding/success': typeof OnboardingRouteWapperSuccessLazyRoute
  '/reports/candidate-report/$rid': typeof ReportsCandidateReportRidLazyRoute
  '/assessments': typeof AuthenticatedAssessmentsIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/sign-up': typeof AuthSignUpIndexLazyRoute
  '/apps': typeof AuthenticatedAppsIndexLazyRoute
  '/calendar': typeof AuthenticatedCalendarIndexLazyRoute
  '/database': typeof AuthenticatedDatabaseIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/interviews': typeof AuthenticatedInterviewsIndexLazyRoute
  '/jobs': typeof AuthenticatedJobsIndexLazyRoute
  '/resdb': typeof AuthenticatedResdbIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/submissions': typeof AuthenticatedSubmissionsIndexLazyRoute
  '/support': typeof AuthenticatedSupportIndexLazyRoute
  '/talent-scout': typeof AuthenticatedTalentScoutIndexLazyRoute
  '/onboarding/profile': typeof OnboardingProfileIndexLazyRoute
  '/jobs/$jobId/configure': typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  '/apps/callback/google-oauth': typeof AuthenticatedAppsCallbackGoogleOauthLazyRoute
  '/database/candidate/$id': typeof AuthenticatedDatabaseCandidateIdLazyRoute
  '/jobs/$jobId/client-submissions': typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  '/jobs/$jobId/recommendations': typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  '/jobs/$jobId/refine': typeof AuthenticatedJobsJobIdRefineLazyRoute
  '/jobs/$jobId/source-candidates': typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  '/settings/database/export': typeof AuthenticatedSettingsDatabaseExportLazyRoute
  '/settings/operation-log/$operation_id': typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  '/auth/callback': typeof AuthAuthCallbackIndexRoute
  '/clients/$clientId': typeof AuthenticatedClientsClientIdIndexRoute
  '/auth/talent-scout': typeof AuthAuthTalentScoutIndexLazyRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdIndexLazyRoute
  '/onboarding/complete': typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  '/settings/operation-log': typeof AuthenticatedSettingsOperationLogIndexLazyRoute
  '/clients/$clientId/submission/$submissionId': typeof AuthenticatedClientsClientIdSubmissionSubmissionIdRoute
  '/jobs/$jobId/candidate/$id': typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  '/jobs/$jobId/configure/export': typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  '/jobs/$jobId/configure/publish': typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  '/jobs/$jobId/configure/triggers': typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
  '/clients/$clientId/submission': typeof AuthenticatedClientsClientIdSubmissionIndexRoute
  '/jobs/$jobId/assessments': typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/canny': typeof CannyRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/oneauth': typeof OneauthRouteRouteWithChildren
  '/organizations': typeof OrganizationsRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/_oauth-callbacks/callback': typeof OauthCallbacksCallbackRouteRouteWithChildren
  '/onboarding/_route-wapper': typeof OnboardingRouteWapperRouteRouteWithChildren
  '/onboarding/profile': typeof OnboardingProfileRouteRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/_auth/unsubscribe': typeof AuthUnsubscribeLazyRoute
  '/_authenticated/developer-hub': typeof AuthenticatedDeveloperHubLazyRoute
  '/canny/sso': typeof CannySsoLazyRoute
  '/oneauth/$token': typeof OneauthTokenLazyRoute
  '/oneauth/connect': typeof OneauthConnectLazyRoute
  '/org/not-found': typeof OrgNotFoundLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/organizations/': typeof OrganizationsIndexLazyRoute
  '/_auth/auth/talent-scout': typeof AuthAuthTalentScoutRouteRouteWithChildren
  '/_authenticated/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  '/_auth/auth/set-password': typeof AuthAuthSetPasswordRoute
  '/_authenticated/apps/gmail': typeof AuthenticatedAppsGmailRoute
  '/_authenticated/assessments/$assessmentsId': typeof AuthenticatedAssessmentsAssessmentsIdRoute
  '/_authenticated/settings/manage-team': typeof AuthenticatedSettingsManageTeamRoute
  '/_auth/sign-up/email-sent': typeof AuthSignUpEmailSentLazyRoute
  '/_authenticated/apps/checkr': typeof AuthenticatedAppsCheckrLazyRoute
  '/_authenticated/apps/google-calendar': typeof AuthenticatedAppsGoogleCalendarLazyRoute
  '/_authenticated/apps/hackerrank': typeof AuthenticatedAppsHackerrankLazyRoute
  '/_authenticated/apps/indeed': typeof AuthenticatedAppsIndeedLazyRoute
  '/_authenticated/apps/linkedin': typeof AuthenticatedAppsLinkedinLazyRoute
  '/_authenticated/apps/mailchimp': typeof AuthenticatedAppsMailchimpLazyRoute
  '/_authenticated/apps/microsoft-teams': typeof AuthenticatedAppsMicrosoftTeamsLazyRoute
  '/_authenticated/apps/naukri': typeof AuthenticatedAppsNaukriLazyRoute
  '/_authenticated/apps/outlook': typeof AuthenticatedAppsOutlookLazyRoute
  '/_authenticated/apps/outlook-calendar': typeof AuthenticatedAppsOutlookCalendarLazyRoute
  '/_authenticated/apps/rippling': typeof AuthenticatedAppsRipplingLazyRoute
  '/_authenticated/apps/slack': typeof AuthenticatedAppsSlackLazyRoute
  '/_authenticated/apps/twilio-whatsapp': typeof AuthenticatedAppsTwilioWhatsappLazyRoute
  '/_authenticated/apps/zohodesk': typeof AuthenticatedAppsZohodeskLazyRoute
  '/_authenticated/apps/zoom': typeof AuthenticatedAppsZoomLazyRoute
  '/_authenticated/database/sync': typeof AuthenticatedDatabaseSyncLazyRoute
  '/_authenticated/interviews/dossier': typeof AuthenticatedInterviewsDossierLazyRoute
  '/_authenticated/jobs/create': typeof AuthenticatedJobsCreateLazyRoute
  '/_authenticated/resdb/$id': typeof AuthenticatedResdbIdLazyRoute
  '/_authenticated/settings/activity-log': typeof AuthenticatedSettingsActivityLogLazyRoute
  '/_authenticated/settings/ai-features': typeof AuthenticatedSettingsAiFeaturesLazyRoute
  '/_authenticated/settings/ai-observability': typeof AuthenticatedSettingsAiObservabilityLazyRoute
  '/_authenticated/settings/ai-sourcing': typeof AuthenticatedSettingsAiSourcingLazyRoute
  '/_authenticated/settings/analytics': typeof AuthenticatedSettingsAnalyticsLazyRoute
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysLazyRoute
  '/_authenticated/settings/assessment': typeof AuthenticatedSettingsAssessmentLazyRoute
  '/_authenticated/settings/audio-monitor': typeof AuthenticatedSettingsAudioMonitorLazyRoute
  '/_authenticated/settings/behavioral': typeof AuthenticatedSettingsBehavioralLazyRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/_authenticated/settings/browser-focus': typeof AuthenticatedSettingsBrowserFocusLazyRoute
  '/_authenticated/settings/browser-integrity': typeof AuthenticatedSettingsBrowserIntegrityLazyRoute
  '/_authenticated/settings/calendar-availability': typeof AuthenticatedSettingsCalendarAvailabilityLazyRoute
  '/_authenticated/settings/candidate-experience': typeof AuthenticatedSettingsCandidateExperienceLazyRoute
  '/_authenticated/settings/candidate-growth': typeof AuthenticatedSettingsCandidateGrowthLazyRoute
  '/_authenticated/settings/candidate-identity': typeof AuthenticatedSettingsCandidateIdentityLazyRoute
  '/_authenticated/settings/candidate-journey': typeof AuthenticatedSettingsCandidateJourneyLazyRoute
  '/_authenticated/settings/candidate-success': typeof AuthenticatedSettingsCandidateSuccessLazyRoute
  '/_authenticated/settings/candidate-workspace': typeof AuthenticatedSettingsCandidateWorkspaceLazyRoute
  '/_authenticated/settings/career-intelligence': typeof AuthenticatedSettingsCareerIntelligenceLazyRoute
  '/_authenticated/settings/career-pages': typeof AuthenticatedSettingsCareerPagesLazyRoute
  '/_authenticated/settings/career-twin': typeof AuthenticatedSettingsCareerTwinLazyRoute
  '/_authenticated/settings/communications': typeof AuthenticatedSettingsCommunicationsLazyRoute
  '/_authenticated/settings/compensation': typeof AuthenticatedSettingsCompensationLazyRoute
  '/_authenticated/settings/credential': typeof AuthenticatedSettingsCredentialLazyRoute
  '/_authenticated/settings/crm-sequences': typeof AuthenticatedSettingsCrmSequencesLazyRoute
  '/_authenticated/settings/custom-reports': typeof AuthenticatedSettingsCustomReportsLazyRoute
  '/_authenticated/settings/decision-intelligence': typeof AuthenticatedSettingsDecisionIntelligenceLazyRoute
  '/_authenticated/settings/dei': typeof AuthenticatedSettingsDeiLazyRoute
  '/_authenticated/settings/device-presence': typeof AuthenticatedSettingsDevicePresenceLazyRoute
  '/_authenticated/settings/engineering-sim': typeof AuthenticatedSettingsEngineeringSimLazyRoute
  '/_authenticated/settings/enterprise': typeof AuthenticatedSettingsEnterpriseLazyRoute
  '/_authenticated/settings/face-presence': typeof AuthenticatedSettingsFacePresenceLazyRoute
  '/_authenticated/settings/head-pose': typeof AuthenticatedSettingsHeadPoseLazyRoute
  '/_authenticated/settings/hiring-blueprint': typeof AuthenticatedSettingsHiringBlueprintLazyRoute
  '/_authenticated/settings/hiring-intelligence': typeof AuthenticatedSettingsHiringIntelligenceLazyRoute
  '/_authenticated/settings/hiring-predictions': typeof AuthenticatedSettingsHiringPredictionsLazyRoute
  '/_authenticated/settings/interview-copilot': typeof AuthenticatedSettingsInterviewCopilotLazyRoute
  '/_authenticated/settings/interview-integrity': typeof AuthenticatedSettingsInterviewIntegrityLazyRoute
  '/_authenticated/settings/interview-intelligence': typeof AuthenticatedSettingsInterviewIntelligenceLazyRoute
  '/_authenticated/settings/interview-practice': typeof AuthenticatedSettingsInterviewPracticeLazyRoute
  '/_authenticated/settings/job-quality': typeof AuthenticatedSettingsJobQualityLazyRoute
  '/_authenticated/settings/offer-intelligence': typeof AuthenticatedSettingsOfferIntelligenceLazyRoute
  '/_authenticated/settings/opportunity': typeof AuthenticatedSettingsOpportunityLazyRoute
  '/_authenticated/settings/person-presence': typeof AuthenticatedSettingsPersonPresenceLazyRoute
  '/_authenticated/settings/pipelines': typeof AuthenticatedSettingsPipelinesLazyRoute
  '/_authenticated/settings/recruiter-workspace': typeof AuthenticatedSettingsRecruiterWorkspaceLazyRoute
  '/_authenticated/settings/recruitment': typeof AuthenticatedSettingsRecruitmentLazyRoute
  '/_authenticated/settings/recruitment-comms': typeof AuthenticatedSettingsRecruitmentCommsLazyRoute
  '/_authenticated/settings/resume-intelligence': typeof AuthenticatedSettingsResumeIntelligenceLazyRoute
  '/_authenticated/settings/resume-trust': typeof AuthenticatedSettingsResumeTrustLazyRoute
  '/_authenticated/settings/retention': typeof AuthenticatedSettingsRetentionLazyRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityLazyRoute
  '/_authenticated/settings/simulation': typeof AuthenticatedSettingsSimulationLazyRoute
  '/_authenticated/settings/speech-intelligence': typeof AuthenticatedSettingsSpeechIntelligenceLazyRoute
  '/_authenticated/settings/talent-acquisition': typeof AuthenticatedSettingsTalentAcquisitionLazyRoute
  '/_authenticated/settings/talent-discovery': typeof AuthenticatedSettingsTalentDiscoveryLazyRoute
  '/_authenticated/settings/talent-graph': typeof AuthenticatedSettingsTalentGraphLazyRoute
  '/_authenticated/settings/universal-search': typeof AuthenticatedSettingsUniversalSearchLazyRoute
  '/_authenticated/settings/velocity': typeof AuthenticatedSettingsVelocityLazyRoute
  '/_authenticated/settings/video-interview': typeof AuthenticatedSettingsVideoInterviewLazyRoute
  '/_authenticated/settings/vision': typeof AuthenticatedSettingsVisionLazyRoute
  '/_authenticated/settings/visual-attention': typeof AuthenticatedSettingsVisualAttentionLazyRoute
  '/_authenticated/settings/vocal-intelligence': typeof AuthenticatedSettingsVocalIntelligenceLazyRoute
  '/_authenticated/settings/voice-verification': typeof AuthenticatedSettingsVoiceVerificationLazyRoute
  '/_authenticated/settings/webhooks': typeof AuthenticatedSettingsWebhooksLazyRoute
  '/_authenticated/settings/workspace-integrity': typeof AuthenticatedSettingsWorkspaceIntegrityLazyRoute
  '/_authenticated/talent-scout/$recordId': typeof AuthenticatedTalentScoutRecordIdLazyRoute
  '/_oauth-callbacks/callback/google-oauth': typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  '/_oauth-callbacks/callback/microsoft-oauth': typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  '/_oauth-callbacks/callback/zoom-oauth': typeof OauthCallbacksCallbackZoomOauthLazyRoute
  '/onboarding/_route-wapper/create-org': typeof OnboardingRouteWapperCreateOrgLazyRoute
  '/onboarding/_route-wapper/success': typeof OnboardingRouteWapperSuccessLazyRoute
  '/reports/candidate-report/$rid': typeof ReportsCandidateReportRidLazyRoute
  '/_authenticated/assessments/': typeof AuthenticatedAssessmentsIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_auth/sign-up/': typeof AuthSignUpIndexLazyRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexLazyRoute
  '/_authenticated/calendar/': typeof AuthenticatedCalendarIndexLazyRoute
  '/_authenticated/database/': typeof AuthenticatedDatabaseIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/interviews/': typeof AuthenticatedInterviewsIndexLazyRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexLazyRoute
  '/_authenticated/resdb/': typeof AuthenticatedResdbIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/submissions/': typeof AuthenticatedSubmissionsIndexLazyRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexLazyRoute
  '/_authenticated/talent-scout/': typeof AuthenticatedTalentScoutIndexLazyRoute
  '/onboarding/profile/': typeof OnboardingProfileIndexLazyRoute
  '/_authenticated/jobs/$jobId/configure': typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  '/_authenticated/apps/callback/google-oauth': typeof AuthenticatedAppsCallbackGoogleOauthLazyRoute
  '/_authenticated/database/candidate/$id': typeof AuthenticatedDatabaseCandidateIdLazyRoute
  '/_authenticated/jobs/$jobId/client-submissions': typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  '/_authenticated/jobs/$jobId/recommendations': typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  '/_authenticated/jobs/$jobId/refine': typeof AuthenticatedJobsJobIdRefineLazyRoute
  '/_authenticated/jobs/$jobId/source-candidates': typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  '/_authenticated/settings/database/export': typeof AuthenticatedSettingsDatabaseExportLazyRoute
  '/_authenticated/settings/operation-log/$operation_id': typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  '/_auth/auth/callback/': typeof AuthAuthCallbackIndexRoute
  '/_authenticated/clients/$clientId/': typeof AuthenticatedClientsClientIdIndexRoute
  '/_auth/auth/talent-scout/': typeof AuthAuthTalentScoutIndexLazyRoute
  '/_authenticated/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexLazyRoute
  '/_authenticated/onboarding/complete/': typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  '/_authenticated/settings/operation-log/': typeof AuthenticatedSettingsOperationLogIndexLazyRoute
  '/_authenticated/clients/$clientId/submission/$submissionId': typeof AuthenticatedClientsClientIdSubmissionSubmissionIdRoute
  '/_authenticated/jobs/$jobId/candidate/$id': typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  '/_authenticated/jobs/$jobId/configure/export': typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  '/_authenticated/jobs/$jobId/configure/publish': typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  '/_authenticated/jobs/$jobId/configure/triggers': typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
  '/_authenticated/clients/$clientId/submission/': typeof AuthenticatedClientsClientIdSubmissionIndexRoute
  '/_authenticated/jobs/$jobId/assessments/': typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/canny'
    | '/onboarding'
    | '/oneauth'
    | '/organizations'
    | '/accept-invite'
    | '/callback'
    | '/onboarding/profile'
    | '/login'
    | '/sign-in'
    | '/settings'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/forgot-password'
    | '/unsubscribe'
    | '/developer-hub'
    | '/canny/sso'
    | '/oneauth/$token'
    | '/oneauth/connect'
    | '/org/not-found'
    | '/'
    | '/organizations/'
    | '/auth/talent-scout'
    | '/jobs/$jobId'
    | '/auth/set-password'
    | '/apps/gmail'
    | '/assessments/$assessmentsId'
    | '/settings/manage-team'
    | '/sign-up/email-sent'
    | '/apps/checkr'
    | '/apps/google-calendar'
    | '/apps/hackerrank'
    | '/apps/indeed'
    | '/apps/linkedin'
    | '/apps/mailchimp'
    | '/apps/microsoft-teams'
    | '/apps/naukri'
    | '/apps/outlook'
    | '/apps/outlook-calendar'
    | '/apps/rippling'
    | '/apps/slack'
    | '/apps/twilio-whatsapp'
    | '/apps/zohodesk'
    | '/apps/zoom'
    | '/database/sync'
    | '/interviews/dossier'
    | '/jobs/create'
    | '/resdb/$id'
    | '/settings/activity-log'
    | '/settings/ai-features'
    | '/settings/ai-observability'
    | '/settings/ai-sourcing'
    | '/settings/analytics'
    | '/settings/api-keys'
    | '/settings/assessment'
    | '/settings/audio-monitor'
    | '/settings/behavioral'
    | '/settings/billing'
    | '/settings/browser-focus'
    | '/settings/browser-integrity'
    | '/settings/calendar-availability'
    | '/settings/candidate-experience'
    | '/settings/candidate-growth'
    | '/settings/candidate-identity'
    | '/settings/candidate-journey'
    | '/settings/candidate-success'
    | '/settings/candidate-workspace'
    | '/settings/career-intelligence'
    | '/settings/career-pages'
    | '/settings/career-twin'
    | '/settings/communications'
    | '/settings/compensation'
    | '/settings/credential'
    | '/settings/crm-sequences'
    | '/settings/custom-reports'
    | '/settings/decision-intelligence'
    | '/settings/dei'
    | '/settings/device-presence'
    | '/settings/engineering-sim'
    | '/settings/enterprise'
    | '/settings/face-presence'
    | '/settings/head-pose'
    | '/settings/hiring-blueprint'
    | '/settings/hiring-intelligence'
    | '/settings/hiring-predictions'
    | '/settings/interview-copilot'
    | '/settings/interview-integrity'
    | '/settings/interview-intelligence'
    | '/settings/interview-practice'
    | '/settings/job-quality'
    | '/settings/offer-intelligence'
    | '/settings/opportunity'
    | '/settings/person-presence'
    | '/settings/pipelines'
    | '/settings/recruiter-workspace'
    | '/settings/recruitment'
    | '/settings/recruitment-comms'
    | '/settings/resume-intelligence'
    | '/settings/resume-trust'
    | '/settings/retention'
    | '/settings/security'
    | '/settings/simulation'
    | '/settings/speech-intelligence'
    | '/settings/talent-acquisition'
    | '/settings/talent-discovery'
    | '/settings/talent-graph'
    | '/settings/universal-search'
    | '/settings/velocity'
    | '/settings/video-interview'
    | '/settings/vision'
    | '/settings/visual-attention'
    | '/settings/vocal-intelligence'
    | '/settings/voice-verification'
    | '/settings/webhooks'
    | '/settings/workspace-integrity'
    | '/talent-scout/$recordId'
    | '/callback/google-oauth'
    | '/callback/microsoft-oauth'
    | '/callback/zoom-oauth'
    | '/onboarding/create-org'
    | '/onboarding/success'
    | '/reports/candidate-report/$rid'
    | '/assessments'
    | '/clients'
    | '/sign-up'
    | '/apps'
    | '/calendar'
    | '/database'
    | '/help-center'
    | '/interviews'
    | '/jobs'
    | '/resdb'
    | '/settings/'
    | '/submissions'
    | '/support'
    | '/talent-scout'
    | '/onboarding/profile/'
    | '/jobs/$jobId/configure'
    | '/apps/callback/google-oauth'
    | '/database/candidate/$id'
    | '/jobs/$jobId/client-submissions'
    | '/jobs/$jobId/recommendations'
    | '/jobs/$jobId/refine'
    | '/jobs/$jobId/source-candidates'
    | '/settings/database/export'
    | '/settings/operation-log/$operation_id'
    | '/auth/callback'
    | '/clients/$clientId'
    | '/auth/talent-scout/'
    | '/jobs/$jobId/'
    | '/onboarding/complete'
    | '/settings/operation-log'
    | '/clients/$clientId/submission/$submissionId'
    | '/jobs/$jobId/candidate/$id'
    | '/jobs/$jobId/configure/export'
    | '/jobs/$jobId/configure/publish'
    | '/jobs/$jobId/configure/triggers'
    | '/clients/$clientId/submission'
    | '/jobs/$jobId/assessments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/canny'
    | '/onboarding'
    | '/oneauth'
    | '/accept-invite'
    | '/callback'
    | '/login'
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/forgot-password'
    | '/unsubscribe'
    | '/developer-hub'
    | '/canny/sso'
    | '/oneauth/$token'
    | '/oneauth/connect'
    | '/org/not-found'
    | '/'
    | '/organizations'
    | '/auth/set-password'
    | '/apps/gmail'
    | '/assessments/$assessmentsId'
    | '/settings/manage-team'
    | '/sign-up/email-sent'
    | '/apps/checkr'
    | '/apps/google-calendar'
    | '/apps/hackerrank'
    | '/apps/indeed'
    | '/apps/linkedin'
    | '/apps/mailchimp'
    | '/apps/microsoft-teams'
    | '/apps/naukri'
    | '/apps/outlook'
    | '/apps/outlook-calendar'
    | '/apps/rippling'
    | '/apps/slack'
    | '/apps/twilio-whatsapp'
    | '/apps/zohodesk'
    | '/apps/zoom'
    | '/database/sync'
    | '/interviews/dossier'
    | '/jobs/create'
    | '/resdb/$id'
    | '/settings/activity-log'
    | '/settings/ai-features'
    | '/settings/ai-observability'
    | '/settings/ai-sourcing'
    | '/settings/analytics'
    | '/settings/api-keys'
    | '/settings/assessment'
    | '/settings/audio-monitor'
    | '/settings/behavioral'
    | '/settings/billing'
    | '/settings/browser-focus'
    | '/settings/browser-integrity'
    | '/settings/calendar-availability'
    | '/settings/candidate-experience'
    | '/settings/candidate-growth'
    | '/settings/candidate-identity'
    | '/settings/candidate-journey'
    | '/settings/candidate-success'
    | '/settings/candidate-workspace'
    | '/settings/career-intelligence'
    | '/settings/career-pages'
    | '/settings/career-twin'
    | '/settings/communications'
    | '/settings/compensation'
    | '/settings/credential'
    | '/settings/crm-sequences'
    | '/settings/custom-reports'
    | '/settings/decision-intelligence'
    | '/settings/dei'
    | '/settings/device-presence'
    | '/settings/engineering-sim'
    | '/settings/enterprise'
    | '/settings/face-presence'
    | '/settings/head-pose'
    | '/settings/hiring-blueprint'
    | '/settings/hiring-intelligence'
    | '/settings/hiring-predictions'
    | '/settings/interview-copilot'
    | '/settings/interview-integrity'
    | '/settings/interview-intelligence'
    | '/settings/interview-practice'
    | '/settings/job-quality'
    | '/settings/offer-intelligence'
    | '/settings/opportunity'
    | '/settings/person-presence'
    | '/settings/pipelines'
    | '/settings/recruiter-workspace'
    | '/settings/recruitment'
    | '/settings/recruitment-comms'
    | '/settings/resume-intelligence'
    | '/settings/resume-trust'
    | '/settings/retention'
    | '/settings/security'
    | '/settings/simulation'
    | '/settings/speech-intelligence'
    | '/settings/talent-acquisition'
    | '/settings/talent-discovery'
    | '/settings/talent-graph'
    | '/settings/universal-search'
    | '/settings/velocity'
    | '/settings/video-interview'
    | '/settings/vision'
    | '/settings/visual-attention'
    | '/settings/vocal-intelligence'
    | '/settings/voice-verification'
    | '/settings/webhooks'
    | '/settings/workspace-integrity'
    | '/talent-scout/$recordId'
    | '/callback/google-oauth'
    | '/callback/microsoft-oauth'
    | '/callback/zoom-oauth'
    | '/onboarding/create-org'
    | '/onboarding/success'
    | '/reports/candidate-report/$rid'
    | '/assessments'
    | '/clients'
    | '/sign-up'
    | '/apps'
    | '/calendar'
    | '/database'
    | '/help-center'
    | '/interviews'
    | '/jobs'
    | '/resdb'
    | '/settings'
    | '/submissions'
    | '/support'
    | '/talent-scout'
    | '/onboarding/profile'
    | '/jobs/$jobId/configure'
    | '/apps/callback/google-oauth'
    | '/database/candidate/$id'
    | '/jobs/$jobId/client-submissions'
    | '/jobs/$jobId/recommendations'
    | '/jobs/$jobId/refine'
    | '/jobs/$jobId/source-candidates'
    | '/settings/database/export'
    | '/settings/operation-log/$operation_id'
    | '/auth/callback'
    | '/clients/$clientId'
    | '/auth/talent-scout'
    | '/jobs/$jobId'
    | '/onboarding/complete'
    | '/settings/operation-log'
    | '/clients/$clientId/submission/$submissionId'
    | '/jobs/$jobId/candidate/$id'
    | '/jobs/$jobId/configure/export'
    | '/jobs/$jobId/configure/publish'
    | '/jobs/$jobId/configure/triggers'
    | '/clients/$clientId/submission'
    | '/jobs/$jobId/assessments'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/canny'
    | '/onboarding'
    | '/oneauth'
    | '/organizations'
    | '/accept-invite'
    | '/_oauth-callbacks/callback'
    | '/onboarding/_route-wapper'
    | '/onboarding/profile'
    | '/_auth/login'
    | '/_auth/sign-in'
    | '/_authenticated/settings'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_auth/forgot-password'
    | '/_auth/unsubscribe'
    | '/_authenticated/developer-hub'
    | '/canny/sso'
    | '/oneauth/$token'
    | '/oneauth/connect'
    | '/org/not-found'
    | '/_authenticated/'
    | '/organizations/'
    | '/_auth/auth/talent-scout'
    | '/_authenticated/jobs/$jobId'
    | '/_auth/auth/set-password'
    | '/_authenticated/apps/gmail'
    | '/_authenticated/assessments/$assessmentsId'
    | '/_authenticated/settings/manage-team'
    | '/_auth/sign-up/email-sent'
    | '/_authenticated/apps/checkr'
    | '/_authenticated/apps/google-calendar'
    | '/_authenticated/apps/hackerrank'
    | '/_authenticated/apps/indeed'
    | '/_authenticated/apps/linkedin'
    | '/_authenticated/apps/mailchimp'
    | '/_authenticated/apps/microsoft-teams'
    | '/_authenticated/apps/naukri'
    | '/_authenticated/apps/outlook'
    | '/_authenticated/apps/outlook-calendar'
    | '/_authenticated/apps/rippling'
    | '/_authenticated/apps/slack'
    | '/_authenticated/apps/twilio-whatsapp'
    | '/_authenticated/apps/zohodesk'
    | '/_authenticated/apps/zoom'
    | '/_authenticated/database/sync'
    | '/_authenticated/interviews/dossier'
    | '/_authenticated/jobs/create'
    | '/_authenticated/resdb/$id'
    | '/_authenticated/settings/activity-log'
    | '/_authenticated/settings/ai-features'
    | '/_authenticated/settings/ai-observability'
    | '/_authenticated/settings/ai-sourcing'
    | '/_authenticated/settings/analytics'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/assessment'
    | '/_authenticated/settings/audio-monitor'
    | '/_authenticated/settings/behavioral'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/browser-focus'
    | '/_authenticated/settings/browser-integrity'
    | '/_authenticated/settings/calendar-availability'
    | '/_authenticated/settings/candidate-experience'
    | '/_authenticated/settings/candidate-growth'
    | '/_authenticated/settings/candidate-identity'
    | '/_authenticated/settings/candidate-journey'
    | '/_authenticated/settings/candidate-success'
    | '/_authenticated/settings/candidate-workspace'
    | '/_authenticated/settings/career-intelligence'
    | '/_authenticated/settings/career-pages'
    | '/_authenticated/settings/career-twin'
    | '/_authenticated/settings/communications'
    | '/_authenticated/settings/compensation'
    | '/_authenticated/settings/credential'
    | '/_authenticated/settings/crm-sequences'
    | '/_authenticated/settings/custom-reports'
    | '/_authenticated/settings/decision-intelligence'
    | '/_authenticated/settings/dei'
    | '/_authenticated/settings/device-presence'
    | '/_authenticated/settings/engineering-sim'
    | '/_authenticated/settings/enterprise'
    | '/_authenticated/settings/face-presence'
    | '/_authenticated/settings/head-pose'
    | '/_authenticated/settings/hiring-blueprint'
    | '/_authenticated/settings/hiring-intelligence'
    | '/_authenticated/settings/hiring-predictions'
    | '/_authenticated/settings/interview-copilot'
    | '/_authenticated/settings/interview-integrity'
    | '/_authenticated/settings/interview-intelligence'
    | '/_authenticated/settings/interview-practice'
    | '/_authenticated/settings/job-quality'
    | '/_authenticated/settings/offer-intelligence'
    | '/_authenticated/settings/opportunity'
    | '/_authenticated/settings/person-presence'
    | '/_authenticated/settings/pipelines'
    | '/_authenticated/settings/recruiter-workspace'
    | '/_authenticated/settings/recruitment'
    | '/_authenticated/settings/recruitment-comms'
    | '/_authenticated/settings/resume-intelligence'
    | '/_authenticated/settings/resume-trust'
    | '/_authenticated/settings/retention'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/simulation'
    | '/_authenticated/settings/speech-intelligence'
    | '/_authenticated/settings/talent-acquisition'
    | '/_authenticated/settings/talent-discovery'
    | '/_authenticated/settings/talent-graph'
    | '/_authenticated/settings/universal-search'
    | '/_authenticated/settings/velocity'
    | '/_authenticated/settings/video-interview'
    | '/_authenticated/settings/vision'
    | '/_authenticated/settings/visual-attention'
    | '/_authenticated/settings/vocal-intelligence'
    | '/_authenticated/settings/voice-verification'
    | '/_authenticated/settings/webhooks'
    | '/_authenticated/settings/workspace-integrity'
    | '/_authenticated/talent-scout/$recordId'
    | '/_oauth-callbacks/callback/google-oauth'
    | '/_oauth-callbacks/callback/microsoft-oauth'
    | '/_oauth-callbacks/callback/zoom-oauth'
    | '/onboarding/_route-wapper/create-org'
    | '/onboarding/_route-wapper/success'
    | '/reports/candidate-report/$rid'
    | '/_authenticated/assessments/'
    | '/_authenticated/clients/'
    | '/_auth/sign-up/'
    | '/_authenticated/apps/'
    | '/_authenticated/calendar/'
    | '/_authenticated/database/'
    | '/_authenticated/help-center/'
    | '/_authenticated/interviews/'
    | '/_authenticated/jobs/'
    | '/_authenticated/resdb/'
    | '/_authenticated/settings/'
    | '/_authenticated/submissions/'
    | '/_authenticated/support/'
    | '/_authenticated/talent-scout/'
    | '/onboarding/profile/'
    | '/_authenticated/jobs/$jobId/configure'
    | '/_authenticated/apps/callback/google-oauth'
    | '/_authenticated/database/candidate/$id'
    | '/_authenticated/jobs/$jobId/client-submissions'
    | '/_authenticated/jobs/$jobId/recommendations'
    | '/_authenticated/jobs/$jobId/refine'
    | '/_authenticated/jobs/$jobId/source-candidates'
    | '/_authenticated/settings/database/export'
    | '/_authenticated/settings/operation-log/$operation_id'
    | '/_auth/auth/callback/'
    | '/_authenticated/clients/$clientId/'
    | '/_auth/auth/talent-scout/'
    | '/_authenticated/jobs/$jobId/'
    | '/_authenticated/onboarding/complete/'
    | '/_authenticated/settings/operation-log/'
    | '/_authenticated/clients/$clientId/submission/$submissionId'
    | '/_authenticated/jobs/$jobId/candidate/$id'
    | '/_authenticated/jobs/$jobId/configure/export'
    | '/_authenticated/jobs/$jobId/configure/publish'
    | '/_authenticated/jobs/$jobId/configure/triggers'
    | '/_authenticated/clients/$clientId/submission/'
    | '/_authenticated/jobs/$jobId/assessments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  CannyRouteRoute: typeof CannyRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  OneauthRouteRoute: typeof OneauthRouteRouteWithChildren
  OrganizationsRouteRoute: typeof OrganizationsRouteRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  OauthCallbacksCallbackRouteRoute: typeof OauthCallbacksCallbackRouteRouteWithChildren
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
  OrgNotFoundLazyRoute: typeof OrgNotFoundLazyRoute
  ReportsCandidateReportRidLazyRoute: typeof ReportsCandidateReportRidLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oneauth': {
      id: '/oneauth'
      path: '/oneauth'
      fullPath: '/oneauth'
      preLoaderRoute: typeof OneauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/canny': {
      id: '/canny'
      path: '/canny'
      fullPath: '/canny'
      preLoaderRoute: typeof CannyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexLazyRouteImport
      parentRoute: typeof OrganizationsRouteRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/org/not-found': {
      id: '/org/not-found'
      path: '/org/not-found'
      fullPath: '/org/not-found'
      preLoaderRoute: typeof OrgNotFoundLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oneauth/connect': {
      id: '/oneauth/connect'
      path: '/connect'
      fullPath: '/oneauth/connect'
      preLoaderRoute: typeof OneauthConnectLazyRouteImport
      parentRoute: typeof OneauthRouteRoute
    }
    '/oneauth/$token': {
      id: '/oneauth/$token'
      path: '/$token'
      fullPath: '/oneauth/$token'
      preLoaderRoute: typeof OneauthTokenLazyRouteImport
      parentRoute: typeof OneauthRouteRoute
    }
    '/canny/sso': {
      id: '/canny/sso'
      path: '/sso'
      fullPath: '/canny/sso'
      preLoaderRoute: typeof CannySsoLazyRouteImport
      parentRoute: typeof CannyRouteRoute
    }
    '/_authenticated/developer-hub': {
      id: '/_authenticated/developer-hub'
      path: '/developer-hub'
      fullPath: '/developer-hub'
      preLoaderRoute: typeof AuthenticatedDeveloperHubLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/unsubscribe': {
      id: '/_auth/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof AuthUnsubscribeLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileRouteRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/_route-wapper': {
      id: '/onboarding/_route-wapper'
      path: ''
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteWapperRouteRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/_oauth-callbacks/callback': {
      id: '/_oauth-callbacks/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof OauthCallbacksCallbackRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/profile/': {
      id: '/onboarding/profile/'
      path: '/'
      fullPath: '/onboarding/profile/'
      preLoaderRoute: typeof OnboardingProfileIndexLazyRouteImport
      parentRoute: typeof OnboardingProfileRouteRoute
    }
    '/_authenticated/talent-scout/': {
      id: '/_authenticated/talent-scout/'
      path: '/talent-scout'
      fullPath: '/talent-scout'
      preLoaderRoute: typeof AuthenticatedTalentScoutIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/submissions/': {
      id: '/_authenticated/submissions/'
      path: '/submissions'
      fullPath: '/submissions'
      preLoaderRoute: typeof AuthenticatedSubmissionsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/resdb/': {
      id: '/_authenticated/resdb/'
      path: '/resdb'
      fullPath: '/resdb'
      preLoaderRoute: typeof AuthenticatedResdbIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/interviews/': {
      id: '/_authenticated/interviews/'
      path: '/interviews'
      fullPath: '/interviews'
      preLoaderRoute: typeof AuthenticatedInterviewsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/database/': {
      id: '/_authenticated/database/'
      path: '/database'
      fullPath: '/database'
      preLoaderRoute: typeof AuthenticatedDatabaseIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/calendar/': {
      id: '/_authenticated/calendar/'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/sign-up/': {
      id: '/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assessments/': {
      id: '/_authenticated/assessments/'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof AuthenticatedAssessmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/reports/candidate-report/$rid': {
      id: '/reports/candidate-report/$rid'
      path: '/reports/candidate-report/$rid'
      fullPath: '/reports/candidate-report/$rid'
      preLoaderRoute: typeof ReportsCandidateReportRidLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/_route-wapper/success': {
      id: '/onboarding/_route-wapper/success'
      path: '/success'
      fullPath: '/onboarding/success'
      preLoaderRoute: typeof OnboardingRouteWapperSuccessLazyRouteImport
      parentRoute: typeof OnboardingRouteWapperRouteRoute
    }
    '/onboarding/_route-wapper/create-org': {
      id: '/onboarding/_route-wapper/create-org'
      path: '/create-org'
      fullPath: '/onboarding/create-org'
      preLoaderRoute: typeof OnboardingRouteWapperCreateOrgLazyRouteImport
      parentRoute: typeof OnboardingRouteWapperRouteRoute
    }
    '/_oauth-callbacks/callback/zoom-oauth': {
      id: '/_oauth-callbacks/callback/zoom-oauth'
      path: '/zoom-oauth'
      fullPath: '/callback/zoom-oauth'
      preLoaderRoute: typeof OauthCallbacksCallbackZoomOauthLazyRouteImport
      parentRoute: typeof OauthCallbacksCallbackRouteRoute
    }
    '/_oauth-callbacks/callback/microsoft-oauth': {
      id: '/_oauth-callbacks/callback/microsoft-oauth'
      path: '/microsoft-oauth'
      fullPath: '/callback/microsoft-oauth'
      preLoaderRoute: typeof OauthCallbacksCallbackMicrosoftOauthLazyRouteImport
      parentRoute: typeof OauthCallbacksCallbackRouteRoute
    }
    '/_oauth-callbacks/callback/google-oauth': {
      id: '/_oauth-callbacks/callback/google-oauth'
      path: '/google-oauth'
      fullPath: '/callback/google-oauth'
      preLoaderRoute: typeof OauthCallbacksCallbackGoogleOauthLazyRouteImport
      parentRoute: typeof OauthCallbacksCallbackRouteRoute
    }
    '/_authenticated/talent-scout/$recordId': {
      id: '/_authenticated/talent-scout/$recordId'
      path: '/talent-scout/$recordId'
      fullPath: '/talent-scout/$recordId'
      preLoaderRoute: typeof AuthenticatedTalentScoutRecordIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/workspace-integrity': {
      id: '/_authenticated/settings/workspace-integrity'
      path: '/workspace-integrity'
      fullPath: '/settings/workspace-integrity'
      preLoaderRoute: typeof AuthenticatedSettingsWorkspaceIntegrityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/webhooks': {
      id: '/_authenticated/settings/webhooks'
      path: '/webhooks'
      fullPath: '/settings/webhooks'
      preLoaderRoute: typeof AuthenticatedSettingsWebhooksLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/voice-verification': {
      id: '/_authenticated/settings/voice-verification'
      path: '/voice-verification'
      fullPath: '/settings/voice-verification'
      preLoaderRoute: typeof AuthenticatedSettingsVoiceVerificationLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/vocal-intelligence': {
      id: '/_authenticated/settings/vocal-intelligence'
      path: '/vocal-intelligence'
      fullPath: '/settings/vocal-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsVocalIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/visual-attention': {
      id: '/_authenticated/settings/visual-attention'
      path: '/visual-attention'
      fullPath: '/settings/visual-attention'
      preLoaderRoute: typeof AuthenticatedSettingsVisualAttentionLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/vision': {
      id: '/_authenticated/settings/vision'
      path: '/vision'
      fullPath: '/settings/vision'
      preLoaderRoute: typeof AuthenticatedSettingsVisionLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/video-interview': {
      id: '/_authenticated/settings/video-interview'
      path: '/video-interview'
      fullPath: '/settings/video-interview'
      preLoaderRoute: typeof AuthenticatedSettingsVideoInterviewLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/velocity': {
      id: '/_authenticated/settings/velocity'
      path: '/velocity'
      fullPath: '/settings/velocity'
      preLoaderRoute: typeof AuthenticatedSettingsVelocityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/universal-search': {
      id: '/_authenticated/settings/universal-search'
      path: '/universal-search'
      fullPath: '/settings/universal-search'
      preLoaderRoute: typeof AuthenticatedSettingsUniversalSearchLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/talent-graph': {
      id: '/_authenticated/settings/talent-graph'
      path: '/talent-graph'
      fullPath: '/settings/talent-graph'
      preLoaderRoute: typeof AuthenticatedSettingsTalentGraphLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/talent-discovery': {
      id: '/_authenticated/settings/talent-discovery'
      path: '/talent-discovery'
      fullPath: '/settings/talent-discovery'
      preLoaderRoute: typeof AuthenticatedSettingsTalentDiscoveryLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/talent-acquisition': {
      id: '/_authenticated/settings/talent-acquisition'
      path: '/talent-acquisition'
      fullPath: '/settings/talent-acquisition'
      preLoaderRoute: typeof AuthenticatedSettingsTalentAcquisitionLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/speech-intelligence': {
      id: '/_authenticated/settings/speech-intelligence'
      path: '/speech-intelligence'
      fullPath: '/settings/speech-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsSpeechIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/simulation': {
      id: '/_authenticated/settings/simulation'
      path: '/simulation'
      fullPath: '/settings/simulation'
      preLoaderRoute: typeof AuthenticatedSettingsSimulationLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/retention': {
      id: '/_authenticated/settings/retention'
      path: '/retention'
      fullPath: '/settings/retention'
      preLoaderRoute: typeof AuthenticatedSettingsRetentionLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/resume-trust': {
      id: '/_authenticated/settings/resume-trust'
      path: '/resume-trust'
      fullPath: '/settings/resume-trust'
      preLoaderRoute: typeof AuthenticatedSettingsResumeTrustLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/resume-intelligence': {
      id: '/_authenticated/settings/resume-intelligence'
      path: '/resume-intelligence'
      fullPath: '/settings/resume-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsResumeIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/recruitment-comms': {
      id: '/_authenticated/settings/recruitment-comms'
      path: '/recruitment-comms'
      fullPath: '/settings/recruitment-comms'
      preLoaderRoute: typeof AuthenticatedSettingsRecruitmentCommsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/recruitment': {
      id: '/_authenticated/settings/recruitment'
      path: '/recruitment'
      fullPath: '/settings/recruitment'
      preLoaderRoute: typeof AuthenticatedSettingsRecruitmentLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/recruiter-workspace': {
      id: '/_authenticated/settings/recruiter-workspace'
      path: '/recruiter-workspace'
      fullPath: '/settings/recruiter-workspace'
      preLoaderRoute: typeof AuthenticatedSettingsRecruiterWorkspaceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/pipelines': {
      id: '/_authenticated/settings/pipelines'
      path: '/pipelines'
      fullPath: '/settings/pipelines'
      preLoaderRoute: typeof AuthenticatedSettingsPipelinesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/person-presence': {
      id: '/_authenticated/settings/person-presence'
      path: '/person-presence'
      fullPath: '/settings/person-presence'
      preLoaderRoute: typeof AuthenticatedSettingsPersonPresenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/opportunity': {
      id: '/_authenticated/settings/opportunity'
      path: '/opportunity'
      fullPath: '/settings/opportunity'
      preLoaderRoute: typeof AuthenticatedSettingsOpportunityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/offer-intelligence': {
      id: '/_authenticated/settings/offer-intelligence'
      path: '/offer-intelligence'
      fullPath: '/settings/offer-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsOfferIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/job-quality': {
      id: '/_authenticated/settings/job-quality'
      path: '/job-quality'
      fullPath: '/settings/job-quality'
      preLoaderRoute: typeof AuthenticatedSettingsJobQualityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/interview-practice': {
      id: '/_authenticated/settings/interview-practice'
      path: '/interview-practice'
      fullPath: '/settings/interview-practice'
      preLoaderRoute: typeof AuthenticatedSettingsInterviewPracticeLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/interview-intelligence': {
      id: '/_authenticated/settings/interview-intelligence'
      path: '/interview-intelligence'
      fullPath: '/settings/interview-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsInterviewIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/interview-integrity': {
      id: '/_authenticated/settings/interview-integrity'
      path: '/interview-integrity'
      fullPath: '/settings/interview-integrity'
      preLoaderRoute: typeof AuthenticatedSettingsInterviewIntegrityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/interview-copilot': {
      id: '/_authenticated/settings/interview-copilot'
      path: '/interview-copilot'
      fullPath: '/settings/interview-copilot'
      preLoaderRoute: typeof AuthenticatedSettingsInterviewCopilotLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/hiring-predictions': {
      id: '/_authenticated/settings/hiring-predictions'
      path: '/hiring-predictions'
      fullPath: '/settings/hiring-predictions'
      preLoaderRoute: typeof AuthenticatedSettingsHiringPredictionsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/hiring-intelligence': {
      id: '/_authenticated/settings/hiring-intelligence'
      path: '/hiring-intelligence'
      fullPath: '/settings/hiring-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsHiringIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/hiring-blueprint': {
      id: '/_authenticated/settings/hiring-blueprint'
      path: '/hiring-blueprint'
      fullPath: '/settings/hiring-blueprint'
      preLoaderRoute: typeof AuthenticatedSettingsHiringBlueprintLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/head-pose': {
      id: '/_authenticated/settings/head-pose'
      path: '/head-pose'
      fullPath: '/settings/head-pose'
      preLoaderRoute: typeof AuthenticatedSettingsHeadPoseLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/face-presence': {
      id: '/_authenticated/settings/face-presence'
      path: '/face-presence'
      fullPath: '/settings/face-presence'
      preLoaderRoute: typeof AuthenticatedSettingsFacePresenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/enterprise': {
      id: '/_authenticated/settings/enterprise'
      path: '/enterprise'
      fullPath: '/settings/enterprise'
      preLoaderRoute: typeof AuthenticatedSettingsEnterpriseLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/engineering-sim': {
      id: '/_authenticated/settings/engineering-sim'
      path: '/engineering-sim'
      fullPath: '/settings/engineering-sim'
      preLoaderRoute: typeof AuthenticatedSettingsEngineeringSimLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/device-presence': {
      id: '/_authenticated/settings/device-presence'
      path: '/device-presence'
      fullPath: '/settings/device-presence'
      preLoaderRoute: typeof AuthenticatedSettingsDevicePresenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/dei': {
      id: '/_authenticated/settings/dei'
      path: '/dei'
      fullPath: '/settings/dei'
      preLoaderRoute: typeof AuthenticatedSettingsDeiLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/decision-intelligence': {
      id: '/_authenticated/settings/decision-intelligence'
      path: '/decision-intelligence'
      fullPath: '/settings/decision-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsDecisionIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/custom-reports': {
      id: '/_authenticated/settings/custom-reports'
      path: '/custom-reports'
      fullPath: '/settings/custom-reports'
      preLoaderRoute: typeof AuthenticatedSettingsCustomReportsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/crm-sequences': {
      id: '/_authenticated/settings/crm-sequences'
      path: '/crm-sequences'
      fullPath: '/settings/crm-sequences'
      preLoaderRoute: typeof AuthenticatedSettingsCrmSequencesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/credential': {
      id: '/_authenticated/settings/credential'
      path: '/credential'
      fullPath: '/settings/credential'
      preLoaderRoute: typeof AuthenticatedSettingsCredentialLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/compensation': {
      id: '/_authenticated/settings/compensation'
      path: '/compensation'
      fullPath: '/settings/compensation'
      preLoaderRoute: typeof AuthenticatedSettingsCompensationLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/communications': {
      id: '/_authenticated/settings/communications'
      path: '/communications'
      fullPath: '/settings/communications'
      preLoaderRoute: typeof AuthenticatedSettingsCommunicationsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/career-twin': {
      id: '/_authenticated/settings/career-twin'
      path: '/career-twin'
      fullPath: '/settings/career-twin'
      preLoaderRoute: typeof AuthenticatedSettingsCareerTwinLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/career-pages': {
      id: '/_authenticated/settings/career-pages'
      path: '/career-pages'
      fullPath: '/settings/career-pages'
      preLoaderRoute: typeof AuthenticatedSettingsCareerPagesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/career-intelligence': {
      id: '/_authenticated/settings/career-intelligence'
      path: '/career-intelligence'
      fullPath: '/settings/career-intelligence'
      preLoaderRoute: typeof AuthenticatedSettingsCareerIntelligenceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/candidate-workspace': {
      id: '/_authenticated/settings/candidate-workspace'
      path: '/candidate-workspace'
      fullPath: '/settings/candidate-workspace'
      preLoaderRoute: typeof AuthenticatedSettingsCandidateWorkspaceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/candidate-success': {
      id: '/_authenticated/settings/candidate-success'
      path: '/candidate-success'
      fullPath: '/settings/candidate-success'
      preLoaderRoute: typeof AuthenticatedSettingsCandidateSuccessLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/candidate-journey': {
      id: '/_authenticated/settings/candidate-journey'
      path: '/candidate-journey'
      fullPath: '/settings/candidate-journey'
      preLoaderRoute: typeof AuthenticatedSettingsCandidateJourneyLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/candidate-identity': {
      id: '/_authenticated/settings/candidate-identity'
      path: '/candidate-identity'
      fullPath: '/settings/candidate-identity'
      preLoaderRoute: typeof AuthenticatedSettingsCandidateIdentityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/candidate-growth': {
      id: '/_authenticated/settings/candidate-growth'
      path: '/candidate-growth'
      fullPath: '/settings/candidate-growth'
      preLoaderRoute: typeof AuthenticatedSettingsCandidateGrowthLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/candidate-experience': {
      id: '/_authenticated/settings/candidate-experience'
      path: '/candidate-experience'
      fullPath: '/settings/candidate-experience'
      preLoaderRoute: typeof AuthenticatedSettingsCandidateExperienceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/calendar-availability': {
      id: '/_authenticated/settings/calendar-availability'
      path: '/calendar-availability'
      fullPath: '/settings/calendar-availability'
      preLoaderRoute: typeof AuthenticatedSettingsCalendarAvailabilityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/browser-integrity': {
      id: '/_authenticated/settings/browser-integrity'
      path: '/browser-integrity'
      fullPath: '/settings/browser-integrity'
      preLoaderRoute: typeof AuthenticatedSettingsBrowserIntegrityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/browser-focus': {
      id: '/_authenticated/settings/browser-focus'
      path: '/browser-focus'
      fullPath: '/settings/browser-focus'
      preLoaderRoute: typeof AuthenticatedSettingsBrowserFocusLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/behavioral': {
      id: '/_authenticated/settings/behavioral'
      path: '/behavioral'
      fullPath: '/settings/behavioral'
      preLoaderRoute: typeof AuthenticatedSettingsBehavioralLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/audio-monitor': {
      id: '/_authenticated/settings/audio-monitor'
      path: '/audio-monitor'
      fullPath: '/settings/audio-monitor'
      preLoaderRoute: typeof AuthenticatedSettingsAudioMonitorLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/assessment': {
      id: '/_authenticated/settings/assessment'
      path: '/assessment'
      fullPath: '/settings/assessment'
      preLoaderRoute: typeof AuthenticatedSettingsAssessmentLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/analytics': {
      id: '/_authenticated/settings/analytics'
      path: '/analytics'
      fullPath: '/settings/analytics'
      preLoaderRoute: typeof AuthenticatedSettingsAnalyticsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/ai-sourcing': {
      id: '/_authenticated/settings/ai-sourcing'
      path: '/ai-sourcing'
      fullPath: '/settings/ai-sourcing'
      preLoaderRoute: typeof AuthenticatedSettingsAiSourcingLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/ai-observability': {
      id: '/_authenticated/settings/ai-observability'
      path: '/ai-observability'
      fullPath: '/settings/ai-observability'
      preLoaderRoute: typeof AuthenticatedSettingsAiObservabilityLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/ai-features': {
      id: '/_authenticated/settings/ai-features'
      path: '/ai-features'
      fullPath: '/settings/ai-features'
      preLoaderRoute: typeof AuthenticatedSettingsAiFeaturesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/activity-log': {
      id: '/_authenticated/settings/activity-log'
      path: '/activity-log'
      fullPath: '/settings/activity-log'
      preLoaderRoute: typeof AuthenticatedSettingsActivityLogLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/resdb/$id': {
      id: '/_authenticated/resdb/$id'
      path: '/resdb/$id'
      fullPath: '/resdb/$id'
      preLoaderRoute: typeof AuthenticatedResdbIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/create': {
      id: '/_authenticated/jobs/create'
      path: '/jobs/create'
      fullPath: '/jobs/create'
      preLoaderRoute: typeof AuthenticatedJobsCreateLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/interviews/dossier': {
      id: '/_authenticated/interviews/dossier'
      path: '/interviews/dossier'
      fullPath: '/interviews/dossier'
      preLoaderRoute: typeof AuthenticatedInterviewsDossierLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/database/sync': {
      id: '/_authenticated/database/sync'
      path: '/database/sync'
      fullPath: '/database/sync'
      preLoaderRoute: typeof AuthenticatedDatabaseSyncLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/zoom': {
      id: '/_authenticated/apps/zoom'
      path: '/apps/zoom'
      fullPath: '/apps/zoom'
      preLoaderRoute: typeof AuthenticatedAppsZoomLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/zohodesk': {
      id: '/_authenticated/apps/zohodesk'
      path: '/apps/zohodesk'
      fullPath: '/apps/zohodesk'
      preLoaderRoute: typeof AuthenticatedAppsZohodeskLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/twilio-whatsapp': {
      id: '/_authenticated/apps/twilio-whatsapp'
      path: '/apps/twilio-whatsapp'
      fullPath: '/apps/twilio-whatsapp'
      preLoaderRoute: typeof AuthenticatedAppsTwilioWhatsappLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/slack': {
      id: '/_authenticated/apps/slack'
      path: '/apps/slack'
      fullPath: '/apps/slack'
      preLoaderRoute: typeof AuthenticatedAppsSlackLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/rippling': {
      id: '/_authenticated/apps/rippling'
      path: '/apps/rippling'
      fullPath: '/apps/rippling'
      preLoaderRoute: typeof AuthenticatedAppsRipplingLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/outlook-calendar': {
      id: '/_authenticated/apps/outlook-calendar'
      path: '/apps/outlook-calendar'
      fullPath: '/apps/outlook-calendar'
      preLoaderRoute: typeof AuthenticatedAppsOutlookCalendarLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/outlook': {
      id: '/_authenticated/apps/outlook'
      path: '/apps/outlook'
      fullPath: '/apps/outlook'
      preLoaderRoute: typeof AuthenticatedAppsOutlookLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/naukri': {
      id: '/_authenticated/apps/naukri'
      path: '/apps/naukri'
      fullPath: '/apps/naukri'
      preLoaderRoute: typeof AuthenticatedAppsNaukriLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/microsoft-teams': {
      id: '/_authenticated/apps/microsoft-teams'
      path: '/apps/microsoft-teams'
      fullPath: '/apps/microsoft-teams'
      preLoaderRoute: typeof AuthenticatedAppsMicrosoftTeamsLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/mailchimp': {
      id: '/_authenticated/apps/mailchimp'
      path: '/apps/mailchimp'
      fullPath: '/apps/mailchimp'
      preLoaderRoute: typeof AuthenticatedAppsMailchimpLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/linkedin': {
      id: '/_authenticated/apps/linkedin'
      path: '/apps/linkedin'
      fullPath: '/apps/linkedin'
      preLoaderRoute: typeof AuthenticatedAppsLinkedinLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/indeed': {
      id: '/_authenticated/apps/indeed'
      path: '/apps/indeed'
      fullPath: '/apps/indeed'
      preLoaderRoute: typeof AuthenticatedAppsIndeedLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/hackerrank': {
      id: '/_authenticated/apps/hackerrank'
      path: '/apps/hackerrank'
      fullPath: '/apps/hackerrank'
      preLoaderRoute: typeof AuthenticatedAppsHackerrankLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/google-calendar': {
      id: '/_authenticated/apps/google-calendar'
      path: '/apps/google-calendar'
      fullPath: '/apps/google-calendar'
      preLoaderRoute: typeof AuthenticatedAppsGoogleCalendarLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/checkr': {
      id: '/_authenticated/apps/checkr'
      path: '/apps/checkr'
      fullPath: '/apps/checkr'
      preLoaderRoute: typeof AuthenticatedAppsCheckrLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/sign-up/email-sent': {
      id: '/_auth/sign-up/email-sent'
      path: '/sign-up/email-sent'
      fullPath: '/sign-up/email-sent'
      preLoaderRoute: typeof AuthSignUpEmailSentLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/settings/manage-team': {
      id: '/_authenticated/settings/manage-team'
      path: '/manage-team'
      fullPath: '/settings/manage-team'
      preLoaderRoute: typeof AuthenticatedSettingsManageTeamRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/assessments/$assessmentsId': {
      id: '/_authenticated/assessments/$assessmentsId'
      path: '/assessments/$assessmentsId'
      fullPath: '/assessments/$assessmentsId'
      preLoaderRoute: typeof AuthenticatedAssessmentsAssessmentsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/gmail': {
      id: '/_authenticated/apps/gmail'
      path: '/apps/gmail'
      fullPath: '/apps/gmail'
      preLoaderRoute: typeof AuthenticatedAppsGmailRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/auth/set-password': {
      id: '/_auth/auth/set-password'
      path: '/auth/set-password'
      fullPath: '/auth/set-password'
      preLoaderRoute: typeof AuthAuthSetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/jobs/$jobId': {
      id: '/_authenticated/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/auth/talent-scout': {
      id: '/_auth/auth/talent-scout'
      path: '/auth/talent-scout'
      fullPath: '/auth/talent-scout'
      preLoaderRoute: typeof AuthAuthTalentScoutRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/settings/operation-log/': {
      id: '/_authenticated/settings/operation-log/'
      path: '/operation-log'
      fullPath: '/settings/operation-log'
      preLoaderRoute: typeof AuthenticatedSettingsOperationLogIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/onboarding/complete/': {
      id: '/_authenticated/onboarding/complete/'
      path: '/onboarding/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof AuthenticatedOnboardingCompleteIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/': {
      id: '/_authenticated/jobs/$jobId/'
      path: '/'
      fullPath: '/jobs/$jobId/'
      preLoaderRoute: typeof AuthenticatedJobsJobIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_auth/auth/talent-scout/': {
      id: '/_auth/auth/talent-scout/'
      path: '/'
      fullPath: '/auth/talent-scout/'
      preLoaderRoute: typeof AuthAuthTalentScoutIndexLazyRouteImport
      parentRoute: typeof AuthAuthTalentScoutRouteRoute
    }
    '/_authenticated/clients/$clientId/': {
      id: '/_authenticated/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthenticatedClientsClientIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/auth/callback/': {
      id: '/_auth/auth/callback/'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthAuthCallbackIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/settings/operation-log/$operation_id': {
      id: '/_authenticated/settings/operation-log/$operation_id'
      path: '/operation-log/$operation_id'
      fullPath: '/settings/operation-log/$operation_id'
      preLoaderRoute: typeof AuthenticatedSettingsOperationLogOperation_idLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/database/export': {
      id: '/_authenticated/settings/database/export'
      path: '/database/export'
      fullPath: '/settings/database/export'
      preLoaderRoute: typeof AuthenticatedSettingsDatabaseExportLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/jobs/$jobId/source-candidates': {
      id: '/_authenticated/jobs/$jobId/source-candidates'
      path: '/source-candidates'
      fullPath: '/jobs/$jobId/source-candidates'
      preLoaderRoute: typeof AuthenticatedJobsJobIdSourceCandidatesLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/refine': {
      id: '/_authenticated/jobs/$jobId/refine'
      path: '/refine'
      fullPath: '/jobs/$jobId/refine'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRefineLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/recommendations': {
      id: '/_authenticated/jobs/$jobId/recommendations'
      path: '/recommendations'
      fullPath: '/jobs/$jobId/recommendations'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRecommendationsLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/client-submissions': {
      id: '/_authenticated/jobs/$jobId/client-submissions'
      path: '/client-submissions'
      fullPath: '/jobs/$jobId/client-submissions'
      preLoaderRoute: typeof AuthenticatedJobsJobIdClientSubmissionsLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/database/candidate/$id': {
      id: '/_authenticated/database/candidate/$id'
      path: '/database/candidate/$id'
      fullPath: '/database/candidate/$id'
      preLoaderRoute: typeof AuthenticatedDatabaseCandidateIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/callback/google-oauth': {
      id: '/_authenticated/apps/callback/google-oauth'
      path: '/apps/callback/google-oauth'
      fullPath: '/apps/callback/google-oauth'
      preLoaderRoute: typeof AuthenticatedAppsCallbackGoogleOauthLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure': {
      id: '/_authenticated/jobs/$jobId/configure'
      path: '/configure'
      fullPath: '/jobs/$jobId/configure'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigureRouteRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/assessments/': {
      id: '/_authenticated/jobs/$jobId/assessments/'
      path: '/assessments'
      fullPath: '/jobs/$jobId/assessments'
      preLoaderRoute: typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/clients/$clientId/submission/': {
      id: '/_authenticated/clients/$clientId/submission/'
      path: '/clients/$clientId/submission'
      fullPath: '/clients/$clientId/submission'
      preLoaderRoute: typeof AuthenticatedClientsClientIdSubmissionIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure/triggers': {
      id: '/_authenticated/jobs/$jobId/configure/triggers'
      path: '/triggers'
      fullPath: '/jobs/$jobId/configure/triggers'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigureTriggersLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdConfigureRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure/publish': {
      id: '/_authenticated/jobs/$jobId/configure/publish'
      path: '/publish'
      fullPath: '/jobs/$jobId/configure/publish'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigurePublishLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdConfigureRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure/export': {
      id: '/_authenticated/jobs/$jobId/configure/export'
      path: '/export'
      fullPath: '/jobs/$jobId/configure/export'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigureExportLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdConfigureRouteRoute
    }
    '/_authenticated/jobs/$jobId/candidate/$id': {
      id: '/_authenticated/jobs/$jobId/candidate/$id'
      path: '/candidate/$id'
      fullPath: '/jobs/$jobId/candidate/$id'
      preLoaderRoute: typeof AuthenticatedJobsJobIdCandidateIdLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/clients/$clientId/submission/$submissionId': {
      id: '/_authenticated/clients/$clientId/submission/$submissionId'
      path: '/clients/$clientId/submission/$submissionId'
      fullPath: '/clients/$clientId/submission/$submissionId'
      preLoaderRoute: typeof AuthenticatedClientsClientIdSubmissionSubmissionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthAuthTalentScoutRouteRouteChildren {
  AuthAuthTalentScoutIndexLazyRoute: typeof AuthAuthTalentScoutIndexLazyRoute
}

const AuthAuthTalentScoutRouteRouteChildren: AuthAuthTalentScoutRouteRouteChildren =
  {
    AuthAuthTalentScoutIndexLazyRoute: AuthAuthTalentScoutIndexLazyRoute,
  }

const AuthAuthTalentScoutRouteRouteWithChildren =
  AuthAuthTalentScoutRouteRoute._addFileChildren(
    AuthAuthTalentScoutRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthForgotPasswordLazyRoute: typeof AuthForgotPasswordLazyRoute
  AuthUnsubscribeLazyRoute: typeof AuthUnsubscribeLazyRoute
  AuthAuthTalentScoutRouteRoute: typeof AuthAuthTalentScoutRouteRouteWithChildren
  AuthAuthSetPasswordRoute: typeof AuthAuthSetPasswordRoute
  AuthSignUpEmailSentLazyRoute: typeof AuthSignUpEmailSentLazyRoute
  AuthSignUpIndexLazyRoute: typeof AuthSignUpIndexLazyRoute
  AuthAuthCallbackIndexRoute: typeof AuthAuthCallbackIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthForgotPasswordLazyRoute: AuthForgotPasswordLazyRoute,
  AuthUnsubscribeLazyRoute: AuthUnsubscribeLazyRoute,
  AuthAuthTalentScoutRouteRoute: AuthAuthTalentScoutRouteRouteWithChildren,
  AuthAuthSetPasswordRoute: AuthAuthSetPasswordRoute,
  AuthSignUpEmailSentLazyRoute: AuthSignUpEmailSentLazyRoute,
  AuthSignUpIndexLazyRoute: AuthSignUpIndexLazyRoute,
  AuthAuthCallbackIndexRoute: AuthAuthCallbackIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsManageTeamRoute: typeof AuthenticatedSettingsManageTeamRoute
  AuthenticatedSettingsActivityLogLazyRoute: typeof AuthenticatedSettingsActivityLogLazyRoute
  AuthenticatedSettingsAiFeaturesLazyRoute: typeof AuthenticatedSettingsAiFeaturesLazyRoute
  AuthenticatedSettingsAiObservabilityLazyRoute: typeof AuthenticatedSettingsAiObservabilityLazyRoute
  AuthenticatedSettingsAiSourcingLazyRoute: typeof AuthenticatedSettingsAiSourcingLazyRoute
  AuthenticatedSettingsAnalyticsLazyRoute: typeof AuthenticatedSettingsAnalyticsLazyRoute
  AuthenticatedSettingsApiKeysLazyRoute: typeof AuthenticatedSettingsApiKeysLazyRoute
  AuthenticatedSettingsAssessmentLazyRoute: typeof AuthenticatedSettingsAssessmentLazyRoute
  AuthenticatedSettingsAudioMonitorLazyRoute: typeof AuthenticatedSettingsAudioMonitorLazyRoute
  AuthenticatedSettingsBehavioralLazyRoute: typeof AuthenticatedSettingsBehavioralLazyRoute
  AuthenticatedSettingsBillingLazyRoute: typeof AuthenticatedSettingsBillingLazyRoute
  AuthenticatedSettingsBrowserFocusLazyRoute: typeof AuthenticatedSettingsBrowserFocusLazyRoute
  AuthenticatedSettingsBrowserIntegrityLazyRoute: typeof AuthenticatedSettingsBrowserIntegrityLazyRoute
  AuthenticatedSettingsCalendarAvailabilityLazyRoute: typeof AuthenticatedSettingsCalendarAvailabilityLazyRoute
  AuthenticatedSettingsCandidateExperienceLazyRoute: typeof AuthenticatedSettingsCandidateExperienceLazyRoute
  AuthenticatedSettingsCandidateGrowthLazyRoute: typeof AuthenticatedSettingsCandidateGrowthLazyRoute
  AuthenticatedSettingsCandidateIdentityLazyRoute: typeof AuthenticatedSettingsCandidateIdentityLazyRoute
  AuthenticatedSettingsCandidateJourneyLazyRoute: typeof AuthenticatedSettingsCandidateJourneyLazyRoute
  AuthenticatedSettingsCandidateSuccessLazyRoute: typeof AuthenticatedSettingsCandidateSuccessLazyRoute
  AuthenticatedSettingsCandidateWorkspaceLazyRoute: typeof AuthenticatedSettingsCandidateWorkspaceLazyRoute
  AuthenticatedSettingsCareerIntelligenceLazyRoute: typeof AuthenticatedSettingsCareerIntelligenceLazyRoute
  AuthenticatedSettingsCareerPagesLazyRoute: typeof AuthenticatedSettingsCareerPagesLazyRoute
  AuthenticatedSettingsCareerTwinLazyRoute: typeof AuthenticatedSettingsCareerTwinLazyRoute
  AuthenticatedSettingsCommunicationsLazyRoute: typeof AuthenticatedSettingsCommunicationsLazyRoute
  AuthenticatedSettingsCompensationLazyRoute: typeof AuthenticatedSettingsCompensationLazyRoute
  AuthenticatedSettingsCredentialLazyRoute: typeof AuthenticatedSettingsCredentialLazyRoute
  AuthenticatedSettingsCrmSequencesLazyRoute: typeof AuthenticatedSettingsCrmSequencesLazyRoute
  AuthenticatedSettingsCustomReportsLazyRoute: typeof AuthenticatedSettingsCustomReportsLazyRoute
  AuthenticatedSettingsDecisionIntelligenceLazyRoute: typeof AuthenticatedSettingsDecisionIntelligenceLazyRoute
  AuthenticatedSettingsDeiLazyRoute: typeof AuthenticatedSettingsDeiLazyRoute
  AuthenticatedSettingsDevicePresenceLazyRoute: typeof AuthenticatedSettingsDevicePresenceLazyRoute
  AuthenticatedSettingsEngineeringSimLazyRoute: typeof AuthenticatedSettingsEngineeringSimLazyRoute
  AuthenticatedSettingsEnterpriseLazyRoute: typeof AuthenticatedSettingsEnterpriseLazyRoute
  AuthenticatedSettingsFacePresenceLazyRoute: typeof AuthenticatedSettingsFacePresenceLazyRoute
  AuthenticatedSettingsHeadPoseLazyRoute: typeof AuthenticatedSettingsHeadPoseLazyRoute
  AuthenticatedSettingsHiringBlueprintLazyRoute: typeof AuthenticatedSettingsHiringBlueprintLazyRoute
  AuthenticatedSettingsHiringIntelligenceLazyRoute: typeof AuthenticatedSettingsHiringIntelligenceLazyRoute
  AuthenticatedSettingsHiringPredictionsLazyRoute: typeof AuthenticatedSettingsHiringPredictionsLazyRoute
  AuthenticatedSettingsInterviewCopilotLazyRoute: typeof AuthenticatedSettingsInterviewCopilotLazyRoute
  AuthenticatedSettingsInterviewIntegrityLazyRoute: typeof AuthenticatedSettingsInterviewIntegrityLazyRoute
  AuthenticatedSettingsInterviewIntelligenceLazyRoute: typeof AuthenticatedSettingsInterviewIntelligenceLazyRoute
  AuthenticatedSettingsInterviewPracticeLazyRoute: typeof AuthenticatedSettingsInterviewPracticeLazyRoute
  AuthenticatedSettingsJobQualityLazyRoute: typeof AuthenticatedSettingsJobQualityLazyRoute
  AuthenticatedSettingsOfferIntelligenceLazyRoute: typeof AuthenticatedSettingsOfferIntelligenceLazyRoute
  AuthenticatedSettingsOpportunityLazyRoute: typeof AuthenticatedSettingsOpportunityLazyRoute
  AuthenticatedSettingsPersonPresenceLazyRoute: typeof AuthenticatedSettingsPersonPresenceLazyRoute
  AuthenticatedSettingsPipelinesLazyRoute: typeof AuthenticatedSettingsPipelinesLazyRoute
  AuthenticatedSettingsRecruiterWorkspaceLazyRoute: typeof AuthenticatedSettingsRecruiterWorkspaceLazyRoute
  AuthenticatedSettingsRecruitmentLazyRoute: typeof AuthenticatedSettingsRecruitmentLazyRoute
  AuthenticatedSettingsRecruitmentCommsLazyRoute: typeof AuthenticatedSettingsRecruitmentCommsLazyRoute
  AuthenticatedSettingsResumeIntelligenceLazyRoute: typeof AuthenticatedSettingsResumeIntelligenceLazyRoute
  AuthenticatedSettingsResumeTrustLazyRoute: typeof AuthenticatedSettingsResumeTrustLazyRoute
  AuthenticatedSettingsRetentionLazyRoute: typeof AuthenticatedSettingsRetentionLazyRoute
  AuthenticatedSettingsSecurityLazyRoute: typeof AuthenticatedSettingsSecurityLazyRoute
  AuthenticatedSettingsSimulationLazyRoute: typeof AuthenticatedSettingsSimulationLazyRoute
  AuthenticatedSettingsSpeechIntelligenceLazyRoute: typeof AuthenticatedSettingsSpeechIntelligenceLazyRoute
  AuthenticatedSettingsTalentAcquisitionLazyRoute: typeof AuthenticatedSettingsTalentAcquisitionLazyRoute
  AuthenticatedSettingsTalentDiscoveryLazyRoute: typeof AuthenticatedSettingsTalentDiscoveryLazyRoute
  AuthenticatedSettingsTalentGraphLazyRoute: typeof AuthenticatedSettingsTalentGraphLazyRoute
  AuthenticatedSettingsUniversalSearchLazyRoute: typeof AuthenticatedSettingsUniversalSearchLazyRoute
  AuthenticatedSettingsVelocityLazyRoute: typeof AuthenticatedSettingsVelocityLazyRoute
  AuthenticatedSettingsVideoInterviewLazyRoute: typeof AuthenticatedSettingsVideoInterviewLazyRoute
  AuthenticatedSettingsVisionLazyRoute: typeof AuthenticatedSettingsVisionLazyRoute
  AuthenticatedSettingsVisualAttentionLazyRoute: typeof AuthenticatedSettingsVisualAttentionLazyRoute
  AuthenticatedSettingsVocalIntelligenceLazyRoute: typeof AuthenticatedSettingsVocalIntelligenceLazyRoute
  AuthenticatedSettingsVoiceVerificationLazyRoute: typeof AuthenticatedSettingsVoiceVerificationLazyRoute
  AuthenticatedSettingsWebhooksLazyRoute: typeof AuthenticatedSettingsWebhooksLazyRoute
  AuthenticatedSettingsWorkspaceIntegrityLazyRoute: typeof AuthenticatedSettingsWorkspaceIntegrityLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
  AuthenticatedSettingsDatabaseExportLazyRoute: typeof AuthenticatedSettingsDatabaseExportLazyRoute
  AuthenticatedSettingsOperationLogOperation_idLazyRoute: typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  AuthenticatedSettingsOperationLogIndexLazyRoute: typeof AuthenticatedSettingsOperationLogIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsManageTeamRoute: AuthenticatedSettingsManageTeamRoute,
    AuthenticatedSettingsActivityLogLazyRoute:
      AuthenticatedSettingsActivityLogLazyRoute,
    AuthenticatedSettingsAiFeaturesLazyRoute:
      AuthenticatedSettingsAiFeaturesLazyRoute,
    AuthenticatedSettingsAiObservabilityLazyRoute:
      AuthenticatedSettingsAiObservabilityLazyRoute,
    AuthenticatedSettingsAiSourcingLazyRoute:
      AuthenticatedSettingsAiSourcingLazyRoute,
    AuthenticatedSettingsAnalyticsLazyRoute:
      AuthenticatedSettingsAnalyticsLazyRoute,
    AuthenticatedSettingsApiKeysLazyRoute:
      AuthenticatedSettingsApiKeysLazyRoute,
    AuthenticatedSettingsAssessmentLazyRoute:
      AuthenticatedSettingsAssessmentLazyRoute,
    AuthenticatedSettingsAudioMonitorLazyRoute:
      AuthenticatedSettingsAudioMonitorLazyRoute,
    AuthenticatedSettingsBehavioralLazyRoute:
      AuthenticatedSettingsBehavioralLazyRoute,
    AuthenticatedSettingsBillingLazyRoute:
      AuthenticatedSettingsBillingLazyRoute,
    AuthenticatedSettingsBrowserFocusLazyRoute:
      AuthenticatedSettingsBrowserFocusLazyRoute,
    AuthenticatedSettingsBrowserIntegrityLazyRoute:
      AuthenticatedSettingsBrowserIntegrityLazyRoute,
    AuthenticatedSettingsCalendarAvailabilityLazyRoute:
      AuthenticatedSettingsCalendarAvailabilityLazyRoute,
    AuthenticatedSettingsCandidateExperienceLazyRoute:
      AuthenticatedSettingsCandidateExperienceLazyRoute,
    AuthenticatedSettingsCandidateGrowthLazyRoute:
      AuthenticatedSettingsCandidateGrowthLazyRoute,
    AuthenticatedSettingsCandidateIdentityLazyRoute:
      AuthenticatedSettingsCandidateIdentityLazyRoute,
    AuthenticatedSettingsCandidateJourneyLazyRoute:
      AuthenticatedSettingsCandidateJourneyLazyRoute,
    AuthenticatedSettingsCandidateSuccessLazyRoute:
      AuthenticatedSettingsCandidateSuccessLazyRoute,
    AuthenticatedSettingsCandidateWorkspaceLazyRoute:
      AuthenticatedSettingsCandidateWorkspaceLazyRoute,
    AuthenticatedSettingsCareerIntelligenceLazyRoute:
      AuthenticatedSettingsCareerIntelligenceLazyRoute,
    AuthenticatedSettingsCareerPagesLazyRoute:
      AuthenticatedSettingsCareerPagesLazyRoute,
    AuthenticatedSettingsCareerTwinLazyRoute:
      AuthenticatedSettingsCareerTwinLazyRoute,
    AuthenticatedSettingsCommunicationsLazyRoute:
      AuthenticatedSettingsCommunicationsLazyRoute,
    AuthenticatedSettingsCompensationLazyRoute:
      AuthenticatedSettingsCompensationLazyRoute,
    AuthenticatedSettingsCredentialLazyRoute:
      AuthenticatedSettingsCredentialLazyRoute,
    AuthenticatedSettingsCrmSequencesLazyRoute:
      AuthenticatedSettingsCrmSequencesLazyRoute,
    AuthenticatedSettingsCustomReportsLazyRoute:
      AuthenticatedSettingsCustomReportsLazyRoute,
    AuthenticatedSettingsDecisionIntelligenceLazyRoute:
      AuthenticatedSettingsDecisionIntelligenceLazyRoute,
    AuthenticatedSettingsDeiLazyRoute: AuthenticatedSettingsDeiLazyRoute,
    AuthenticatedSettingsDevicePresenceLazyRoute:
      AuthenticatedSettingsDevicePresenceLazyRoute,
    AuthenticatedSettingsEngineeringSimLazyRoute:
      AuthenticatedSettingsEngineeringSimLazyRoute,
    AuthenticatedSettingsEnterpriseLazyRoute:
      AuthenticatedSettingsEnterpriseLazyRoute,
    AuthenticatedSettingsFacePresenceLazyRoute:
      AuthenticatedSettingsFacePresenceLazyRoute,
    AuthenticatedSettingsHeadPoseLazyRoute:
      AuthenticatedSettingsHeadPoseLazyRoute,
    AuthenticatedSettingsHiringBlueprintLazyRoute:
      AuthenticatedSettingsHiringBlueprintLazyRoute,
    AuthenticatedSettingsHiringIntelligenceLazyRoute:
      AuthenticatedSettingsHiringIntelligenceLazyRoute,
    AuthenticatedSettingsHiringPredictionsLazyRoute:
      AuthenticatedSettingsHiringPredictionsLazyRoute,
    AuthenticatedSettingsInterviewCopilotLazyRoute:
      AuthenticatedSettingsInterviewCopilotLazyRoute,
    AuthenticatedSettingsInterviewIntegrityLazyRoute:
      AuthenticatedSettingsInterviewIntegrityLazyRoute,
    AuthenticatedSettingsInterviewIntelligenceLazyRoute:
      AuthenticatedSettingsInterviewIntelligenceLazyRoute,
    AuthenticatedSettingsInterviewPracticeLazyRoute:
      AuthenticatedSettingsInterviewPracticeLazyRoute,
    AuthenticatedSettingsJobQualityLazyRoute:
      AuthenticatedSettingsJobQualityLazyRoute,
    AuthenticatedSettingsOfferIntelligenceLazyRoute:
      AuthenticatedSettingsOfferIntelligenceLazyRoute,
    AuthenticatedSettingsOpportunityLazyRoute:
      AuthenticatedSettingsOpportunityLazyRoute,
    AuthenticatedSettingsPersonPresenceLazyRoute:
      AuthenticatedSettingsPersonPresenceLazyRoute,
    AuthenticatedSettingsPipelinesLazyRoute:
      AuthenticatedSettingsPipelinesLazyRoute,
    AuthenticatedSettingsRecruiterWorkspaceLazyRoute:
      AuthenticatedSettingsRecruiterWorkspaceLazyRoute,
    AuthenticatedSettingsRecruitmentLazyRoute:
      AuthenticatedSettingsRecruitmentLazyRoute,
    AuthenticatedSettingsRecruitmentCommsLazyRoute:
      AuthenticatedSettingsRecruitmentCommsLazyRoute,
    AuthenticatedSettingsResumeIntelligenceLazyRoute:
      AuthenticatedSettingsResumeIntelligenceLazyRoute,
    AuthenticatedSettingsResumeTrustLazyRoute:
      AuthenticatedSettingsResumeTrustLazyRoute,
    AuthenticatedSettingsRetentionLazyRoute:
      AuthenticatedSettingsRetentionLazyRoute,
    AuthenticatedSettingsSecurityLazyRoute:
      AuthenticatedSettingsSecurityLazyRoute,
    AuthenticatedSettingsSimulationLazyRoute:
      AuthenticatedSettingsSimulationLazyRoute,
    AuthenticatedSettingsSpeechIntelligenceLazyRoute:
      AuthenticatedSettingsSpeechIntelligenceLazyRoute,
    AuthenticatedSettingsTalentAcquisitionLazyRoute:
      AuthenticatedSettingsTalentAcquisitionLazyRoute,
    AuthenticatedSettingsTalentDiscoveryLazyRoute:
      AuthenticatedSettingsTalentDiscoveryLazyRoute,
    AuthenticatedSettingsTalentGraphLazyRoute:
      AuthenticatedSettingsTalentGraphLazyRoute,
    AuthenticatedSettingsUniversalSearchLazyRoute:
      AuthenticatedSettingsUniversalSearchLazyRoute,
    AuthenticatedSettingsVelocityLazyRoute:
      AuthenticatedSettingsVelocityLazyRoute,
    AuthenticatedSettingsVideoInterviewLazyRoute:
      AuthenticatedSettingsVideoInterviewLazyRoute,
    AuthenticatedSettingsVisionLazyRoute: AuthenticatedSettingsVisionLazyRoute,
    AuthenticatedSettingsVisualAttentionLazyRoute:
      AuthenticatedSettingsVisualAttentionLazyRoute,
    AuthenticatedSettingsVocalIntelligenceLazyRoute:
      AuthenticatedSettingsVocalIntelligenceLazyRoute,
    AuthenticatedSettingsVoiceVerificationLazyRoute:
      AuthenticatedSettingsVoiceVerificationLazyRoute,
    AuthenticatedSettingsWebhooksLazyRoute:
      AuthenticatedSettingsWebhooksLazyRoute,
    AuthenticatedSettingsWorkspaceIntegrityLazyRoute:
      AuthenticatedSettingsWorkspaceIntegrityLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
    AuthenticatedSettingsDatabaseExportLazyRoute:
      AuthenticatedSettingsDatabaseExportLazyRoute,
    AuthenticatedSettingsOperationLogOperation_idLazyRoute:
      AuthenticatedSettingsOperationLogOperation_idLazyRoute,
    AuthenticatedSettingsOperationLogIndexLazyRoute:
      AuthenticatedSettingsOperationLogIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedJobsJobIdConfigureRouteRouteChildren {
  AuthenticatedJobsJobIdConfigureExportLazyRoute: typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  AuthenticatedJobsJobIdConfigurePublishLazyRoute: typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  AuthenticatedJobsJobIdConfigureTriggersLazyRoute: typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
}

const AuthenticatedJobsJobIdConfigureRouteRouteChildren: AuthenticatedJobsJobIdConfigureRouteRouteChildren =
  {
    AuthenticatedJobsJobIdConfigureExportLazyRoute:
      AuthenticatedJobsJobIdConfigureExportLazyRoute,
    AuthenticatedJobsJobIdConfigurePublishLazyRoute:
      AuthenticatedJobsJobIdConfigurePublishLazyRoute,
    AuthenticatedJobsJobIdConfigureTriggersLazyRoute:
      AuthenticatedJobsJobIdConfigureTriggersLazyRoute,
  }

const AuthenticatedJobsJobIdConfigureRouteRouteWithChildren =
  AuthenticatedJobsJobIdConfigureRouteRoute._addFileChildren(
    AuthenticatedJobsJobIdConfigureRouteRouteChildren,
  )

interface AuthenticatedJobsJobIdRouteRouteChildren {
  AuthenticatedJobsJobIdConfigureRouteRoute: typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  AuthenticatedJobsJobIdClientSubmissionsLazyRoute: typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  AuthenticatedJobsJobIdRecommendationsLazyRoute: typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  AuthenticatedJobsJobIdRefineLazyRoute: typeof AuthenticatedJobsJobIdRefineLazyRoute
  AuthenticatedJobsJobIdSourceCandidatesLazyRoute: typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  AuthenticatedJobsJobIdIndexLazyRoute: typeof AuthenticatedJobsJobIdIndexLazyRoute
  AuthenticatedJobsJobIdCandidateIdLazyRoute: typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  AuthenticatedJobsJobIdAssessmentsIndexLazyRoute: typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}

const AuthenticatedJobsJobIdRouteRouteChildren: AuthenticatedJobsJobIdRouteRouteChildren =
  {
    AuthenticatedJobsJobIdConfigureRouteRoute:
      AuthenticatedJobsJobIdConfigureRouteRouteWithChildren,
    AuthenticatedJobsJobIdClientSubmissionsLazyRoute:
      AuthenticatedJobsJobIdClientSubmissionsLazyRoute,
    AuthenticatedJobsJobIdRecommendationsLazyRoute:
      AuthenticatedJobsJobIdRecommendationsLazyRoute,
    AuthenticatedJobsJobIdRefineLazyRoute:
      AuthenticatedJobsJobIdRefineLazyRoute,
    AuthenticatedJobsJobIdSourceCandidatesLazyRoute:
      AuthenticatedJobsJobIdSourceCandidatesLazyRoute,
    AuthenticatedJobsJobIdIndexLazyRoute: AuthenticatedJobsJobIdIndexLazyRoute,
    AuthenticatedJobsJobIdCandidateIdLazyRoute:
      AuthenticatedJobsJobIdCandidateIdLazyRoute,
    AuthenticatedJobsJobIdAssessmentsIndexLazyRoute:
      AuthenticatedJobsJobIdAssessmentsIndexLazyRoute,
  }

const AuthenticatedJobsJobIdRouteRouteWithChildren =
  AuthenticatedJobsJobIdRouteRoute._addFileChildren(
    AuthenticatedJobsJobIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedDeveloperHubLazyRoute: typeof AuthenticatedDeveloperHubLazyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedJobsJobIdRouteRoute: typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  AuthenticatedAppsGmailRoute: typeof AuthenticatedAppsGmailRoute
  AuthenticatedAssessmentsAssessmentsIdRoute: typeof AuthenticatedAssessmentsAssessmentsIdRoute
  AuthenticatedAppsCheckrLazyRoute: typeof AuthenticatedAppsCheckrLazyRoute
  AuthenticatedAppsGoogleCalendarLazyRoute: typeof AuthenticatedAppsGoogleCalendarLazyRoute
  AuthenticatedAppsHackerrankLazyRoute: typeof AuthenticatedAppsHackerrankLazyRoute
  AuthenticatedAppsIndeedLazyRoute: typeof AuthenticatedAppsIndeedLazyRoute
  AuthenticatedAppsLinkedinLazyRoute: typeof AuthenticatedAppsLinkedinLazyRoute
  AuthenticatedAppsMailchimpLazyRoute: typeof AuthenticatedAppsMailchimpLazyRoute
  AuthenticatedAppsMicrosoftTeamsLazyRoute: typeof AuthenticatedAppsMicrosoftTeamsLazyRoute
  AuthenticatedAppsNaukriLazyRoute: typeof AuthenticatedAppsNaukriLazyRoute
  AuthenticatedAppsOutlookLazyRoute: typeof AuthenticatedAppsOutlookLazyRoute
  AuthenticatedAppsOutlookCalendarLazyRoute: typeof AuthenticatedAppsOutlookCalendarLazyRoute
  AuthenticatedAppsRipplingLazyRoute: typeof AuthenticatedAppsRipplingLazyRoute
  AuthenticatedAppsSlackLazyRoute: typeof AuthenticatedAppsSlackLazyRoute
  AuthenticatedAppsTwilioWhatsappLazyRoute: typeof AuthenticatedAppsTwilioWhatsappLazyRoute
  AuthenticatedAppsZohodeskLazyRoute: typeof AuthenticatedAppsZohodeskLazyRoute
  AuthenticatedAppsZoomLazyRoute: typeof AuthenticatedAppsZoomLazyRoute
  AuthenticatedDatabaseSyncLazyRoute: typeof AuthenticatedDatabaseSyncLazyRoute
  AuthenticatedInterviewsDossierLazyRoute: typeof AuthenticatedInterviewsDossierLazyRoute
  AuthenticatedJobsCreateLazyRoute: typeof AuthenticatedJobsCreateLazyRoute
  AuthenticatedResdbIdLazyRoute: typeof AuthenticatedResdbIdLazyRoute
  AuthenticatedTalentScoutRecordIdLazyRoute: typeof AuthenticatedTalentScoutRecordIdLazyRoute
  AuthenticatedAssessmentsIndexRoute: typeof AuthenticatedAssessmentsIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedAppsIndexLazyRoute: typeof AuthenticatedAppsIndexLazyRoute
  AuthenticatedCalendarIndexLazyRoute: typeof AuthenticatedCalendarIndexLazyRoute
  AuthenticatedDatabaseIndexLazyRoute: typeof AuthenticatedDatabaseIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedInterviewsIndexLazyRoute: typeof AuthenticatedInterviewsIndexLazyRoute
  AuthenticatedJobsIndexLazyRoute: typeof AuthenticatedJobsIndexLazyRoute
  AuthenticatedResdbIndexLazyRoute: typeof AuthenticatedResdbIndexLazyRoute
  AuthenticatedSubmissionsIndexLazyRoute: typeof AuthenticatedSubmissionsIndexLazyRoute
  AuthenticatedSupportIndexLazyRoute: typeof AuthenticatedSupportIndexLazyRoute
  AuthenticatedTalentScoutIndexLazyRoute: typeof AuthenticatedTalentScoutIndexLazyRoute
  AuthenticatedAppsCallbackGoogleOauthLazyRoute: typeof AuthenticatedAppsCallbackGoogleOauthLazyRoute
  AuthenticatedDatabaseCandidateIdLazyRoute: typeof AuthenticatedDatabaseCandidateIdLazyRoute
  AuthenticatedClientsClientIdIndexRoute: typeof AuthenticatedClientsClientIdIndexRoute
  AuthenticatedOnboardingCompleteIndexLazyRoute: typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  AuthenticatedClientsClientIdSubmissionSubmissionIdRoute: typeof AuthenticatedClientsClientIdSubmissionSubmissionIdRoute
  AuthenticatedClientsClientIdSubmissionIndexRoute: typeof AuthenticatedClientsClientIdSubmissionIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedDeveloperHubLazyRoute: AuthenticatedDeveloperHubLazyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedJobsJobIdRouteRoute:
    AuthenticatedJobsJobIdRouteRouteWithChildren,
  AuthenticatedAppsGmailRoute: AuthenticatedAppsGmailRoute,
  AuthenticatedAssessmentsAssessmentsIdRoute:
    AuthenticatedAssessmentsAssessmentsIdRoute,
  AuthenticatedAppsCheckrLazyRoute: AuthenticatedAppsCheckrLazyRoute,
  AuthenticatedAppsGoogleCalendarLazyRoute:
    AuthenticatedAppsGoogleCalendarLazyRoute,
  AuthenticatedAppsHackerrankLazyRoute: AuthenticatedAppsHackerrankLazyRoute,
  AuthenticatedAppsIndeedLazyRoute: AuthenticatedAppsIndeedLazyRoute,
  AuthenticatedAppsLinkedinLazyRoute: AuthenticatedAppsLinkedinLazyRoute,
  AuthenticatedAppsMailchimpLazyRoute: AuthenticatedAppsMailchimpLazyRoute,
  AuthenticatedAppsMicrosoftTeamsLazyRoute:
    AuthenticatedAppsMicrosoftTeamsLazyRoute,
  AuthenticatedAppsNaukriLazyRoute: AuthenticatedAppsNaukriLazyRoute,
  AuthenticatedAppsOutlookLazyRoute: AuthenticatedAppsOutlookLazyRoute,
  AuthenticatedAppsOutlookCalendarLazyRoute:
    AuthenticatedAppsOutlookCalendarLazyRoute,
  AuthenticatedAppsRipplingLazyRoute: AuthenticatedAppsRipplingLazyRoute,
  AuthenticatedAppsSlackLazyRoute: AuthenticatedAppsSlackLazyRoute,
  AuthenticatedAppsTwilioWhatsappLazyRoute:
    AuthenticatedAppsTwilioWhatsappLazyRoute,
  AuthenticatedAppsZohodeskLazyRoute: AuthenticatedAppsZohodeskLazyRoute,
  AuthenticatedAppsZoomLazyRoute: AuthenticatedAppsZoomLazyRoute,
  AuthenticatedDatabaseSyncLazyRoute: AuthenticatedDatabaseSyncLazyRoute,
  AuthenticatedInterviewsDossierLazyRoute:
    AuthenticatedInterviewsDossierLazyRoute,
  AuthenticatedJobsCreateLazyRoute: AuthenticatedJobsCreateLazyRoute,
  AuthenticatedResdbIdLazyRoute: AuthenticatedResdbIdLazyRoute,
  AuthenticatedTalentScoutRecordIdLazyRoute:
    AuthenticatedTalentScoutRecordIdLazyRoute,
  AuthenticatedAssessmentsIndexRoute: AuthenticatedAssessmentsIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedAppsIndexLazyRoute: AuthenticatedAppsIndexLazyRoute,
  AuthenticatedCalendarIndexLazyRoute: AuthenticatedCalendarIndexLazyRoute,
  AuthenticatedDatabaseIndexLazyRoute: AuthenticatedDatabaseIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedInterviewsIndexLazyRoute: AuthenticatedInterviewsIndexLazyRoute,
  AuthenticatedJobsIndexLazyRoute: AuthenticatedJobsIndexLazyRoute,
  AuthenticatedResdbIndexLazyRoute: AuthenticatedResdbIndexLazyRoute,
  AuthenticatedSubmissionsIndexLazyRoute:
    AuthenticatedSubmissionsIndexLazyRoute,
  AuthenticatedSupportIndexLazyRoute: AuthenticatedSupportIndexLazyRoute,
  AuthenticatedTalentScoutIndexLazyRoute:
    AuthenticatedTalentScoutIndexLazyRoute,
  AuthenticatedAppsCallbackGoogleOauthLazyRoute:
    AuthenticatedAppsCallbackGoogleOauthLazyRoute,
  AuthenticatedDatabaseCandidateIdLazyRoute:
    AuthenticatedDatabaseCandidateIdLazyRoute,
  AuthenticatedClientsClientIdIndexRoute:
    AuthenticatedClientsClientIdIndexRoute,
  AuthenticatedOnboardingCompleteIndexLazyRoute:
    AuthenticatedOnboardingCompleteIndexLazyRoute,
  AuthenticatedClientsClientIdSubmissionSubmissionIdRoute:
    AuthenticatedClientsClientIdSubmissionSubmissionIdRoute,
  AuthenticatedClientsClientIdSubmissionIndexRoute:
    AuthenticatedClientsClientIdSubmissionIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface CannyRouteRouteChildren {
  CannySsoLazyRoute: typeof CannySsoLazyRoute
}

const CannyRouteRouteChildren: CannyRouteRouteChildren = {
  CannySsoLazyRoute: CannySsoLazyRoute,
}

const CannyRouteRouteWithChildren = CannyRouteRoute._addFileChildren(
  CannyRouteRouteChildren,
)

interface OnboardingRouteWapperRouteRouteChildren {
  OnboardingRouteWapperCreateOrgLazyRoute: typeof OnboardingRouteWapperCreateOrgLazyRoute
  OnboardingRouteWapperSuccessLazyRoute: typeof OnboardingRouteWapperSuccessLazyRoute
}

const OnboardingRouteWapperRouteRouteChildren: OnboardingRouteWapperRouteRouteChildren =
  {
    OnboardingRouteWapperCreateOrgLazyRoute:
      OnboardingRouteWapperCreateOrgLazyRoute,
    OnboardingRouteWapperSuccessLazyRoute:
      OnboardingRouteWapperSuccessLazyRoute,
  }

const OnboardingRouteWapperRouteRouteWithChildren =
  OnboardingRouteWapperRouteRoute._addFileChildren(
    OnboardingRouteWapperRouteRouteChildren,
  )

interface OnboardingProfileRouteRouteChildren {
  OnboardingProfileIndexLazyRoute: typeof OnboardingProfileIndexLazyRoute
}

const OnboardingProfileRouteRouteChildren: OnboardingProfileRouteRouteChildren =
  {
    OnboardingProfileIndexLazyRoute: OnboardingProfileIndexLazyRoute,
  }

const OnboardingProfileRouteRouteWithChildren =
  OnboardingProfileRouteRoute._addFileChildren(
    OnboardingProfileRouteRouteChildren,
  )

interface OnboardingRouteRouteChildren {
  OnboardingRouteWapperRouteRoute: typeof OnboardingRouteWapperRouteRouteWithChildren
  OnboardingProfileRouteRoute: typeof OnboardingProfileRouteRouteWithChildren
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingRouteWapperRouteRoute: OnboardingRouteWapperRouteRouteWithChildren,
  OnboardingProfileRouteRoute: OnboardingProfileRouteRouteWithChildren,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface OneauthRouteRouteChildren {
  OneauthTokenLazyRoute: typeof OneauthTokenLazyRoute
  OneauthConnectLazyRoute: typeof OneauthConnectLazyRoute
}

const OneauthRouteRouteChildren: OneauthRouteRouteChildren = {
  OneauthTokenLazyRoute: OneauthTokenLazyRoute,
  OneauthConnectLazyRoute: OneauthConnectLazyRoute,
}

const OneauthRouteRouteWithChildren = OneauthRouteRoute._addFileChildren(
  OneauthRouteRouteChildren,
)

interface OrganizationsRouteRouteChildren {
  OrganizationsIndexLazyRoute: typeof OrganizationsIndexLazyRoute
}

const OrganizationsRouteRouteChildren: OrganizationsRouteRouteChildren = {
  OrganizationsIndexLazyRoute: OrganizationsIndexLazyRoute,
}

const OrganizationsRouteRouteWithChildren =
  OrganizationsRouteRoute._addFileChildren(OrganizationsRouteRouteChildren)

interface OauthCallbacksCallbackRouteRouteChildren {
  OauthCallbacksCallbackGoogleOauthLazyRoute: typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  OauthCallbacksCallbackMicrosoftOauthLazyRoute: typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  OauthCallbacksCallbackZoomOauthLazyRoute: typeof OauthCallbacksCallbackZoomOauthLazyRoute
}

const OauthCallbacksCallbackRouteRouteChildren: OauthCallbacksCallbackRouteRouteChildren =
  {
    OauthCallbacksCallbackGoogleOauthLazyRoute:
      OauthCallbacksCallbackGoogleOauthLazyRoute,
    OauthCallbacksCallbackMicrosoftOauthLazyRoute:
      OauthCallbacksCallbackMicrosoftOauthLazyRoute,
    OauthCallbacksCallbackZoomOauthLazyRoute:
      OauthCallbacksCallbackZoomOauthLazyRoute,
  }

const OauthCallbacksCallbackRouteRouteWithChildren =
  OauthCallbacksCallbackRouteRoute._addFileChildren(
    OauthCallbacksCallbackRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  CannyRouteRoute: CannyRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  OneauthRouteRoute: OneauthRouteRouteWithChildren,
  OrganizationsRouteRoute: OrganizationsRouteRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  OauthCallbacksCallbackRouteRoute:
    OauthCallbacksCallbackRouteRouteWithChildren,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  OrgNotFoundLazyRoute: OrgNotFoundLazyRoute,
  ReportsCandidateReportRidLazyRoute: ReportsCandidateReportRidLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
